webpackJsonp([1],Array(34).concat([
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(567),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(588),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var route = 'https://lvosmiles.com/wp-json';

var api = function api() {
  return route;
};

exports.default = api();

/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(581),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>arrow</title><path d=\"M14.86,4.75,28.63,22h-.1l2.4,2.93-2.36,2.92h.07L14.86,45a3.11,3.11,0,0,0,.46,4.12,2.94,2.94,0,0,0,4.12-.46L37,26.71a2.67,2.67,0,0,0,.64-1.83h0A4.32,4.32,0,0,0,37,23.05l-17.57-22A3,3,0,0,0,15.32.63,3,3,0,0,0,14.86,4.75Z\"/></svg>";

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(570),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(237),
  /* template */
  __webpack_require__(592),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_PAGES = exports.GET_PAGES = 'GET_PAGES';
var GET_APP = exports.GET_APP = 'GET_APP';
var VIEW_NAV = exports.VIEW_NAV = 'VIEW_NAV';
var VIEW_BODY = exports.VIEW_BODY = 'VIEW_BODY';
var VIEW_TYPES = exports.VIEW_TYPES = 'VIEW_TYPES';
var VIEW_SHOWMODAL = exports.VIEW_SHOWMODAL = 'VIEW_SHOWMODAL';
var VIEW_MODALCONTENT = exports.VIEW_MODALCONTENT = 'VIEW_MODALCONTENT';

/***/ }),
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(594),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(257);

var _keys2 = _interopRequireDefault(_keys);

var _vue = __webpack_require__(127);

var _vue2 = _interopRequireDefault(_vue);

var _app = __webpack_require__(524);

var _app2 = _interopRequireDefault(_app);

var _router = __webpack_require__(204);

var _router2 = _interopRequireDefault(_router);

var _veeValidate = __webpack_require__(523);

var _veeValidate2 = _interopRequireDefault(_veeValidate);

var _store = __webpack_require__(207);

var _store2 = _interopRequireDefault(_store);

var _filters = __webpack_require__(205);

var customFilters = _interopRequireWildcard(_filters);

var _vueScrollto = __webpack_require__(614);

var _vueScrollto2 = _interopRequireDefault(_vueScrollto);

var _vueWaypoint = __webpack_require__(616);

var _vueWaypoint2 = _interopRequireDefault(_vueWaypoint);

var _vueCarousel = __webpack_require__(63);

var _vueCarousel2 = _interopRequireDefault(_vueCarousel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.productionTip = false;

(0, _keys2.default)(customFilters).forEach(function (key) {
  _vue2.default.filter(key, customFilters[key]);
});

_vue2.default.use(_veeValidate2.default);

_vue2.default.use(_vueScrollto2.default, {
  container: 'body',
  duration: 1500,
  easing: 'ease',
  offset: 0,
  cancelable: true,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

_vue2.default.use(_vueCarousel2.default);
_vue2.default.use(_vueWaypoint2.default);

new _vue2.default({
  router: _router2.default,
  template: '<App/>',
  store: _store2.default,
  render: function render(h) {
    return h(_app2.default);
  }
}).$mount('#app');

/***/ }),
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(127);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(613);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _home = __webpack_require__(559);

var _home2 = _interopRequireDefault(_home);

var _aboutUs = __webpack_require__(555);

var _aboutUs2 = _interopRequireDefault(_aboutUs);

var _comfortCare = __webpack_require__(557);

var _comfortCare2 = _interopRequireDefault(_comfortCare);

var _newPatients = __webpack_require__(560);

var _newPatients2 = _interopRequireDefault(_newPatients);

var _treatment = __webpack_require__(562);

var _treatment2 = _interopRequireDefault(_treatment);

var _accessibility = __webpack_require__(556);

var _accessibility2 = _interopRequireDefault(_accessibility);

var _contactUs = __webpack_require__(558);

var _contactUs2 = _interopRequireDefault(_contactUs);

var _reviews = __webpack_require__(561);

var _reviews2 = _interopRequireDefault(_reviews);

var _welchorthodontics = __webpack_require__(563);

var _welchorthodontics2 = _interopRequireDefault(_welchorthodontics);

var _ = __webpack_require__(554);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var router = new _vueRouter2.default({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    navigation: false,
    component: _home2.default
  }, {
    path: '/about-us',
    name: 'About Us',
    navigation: true,
    component: _aboutUs2.default
  }, {
    path: '/new-patients',
    name: 'New Patients',
    navigation: true,
    component: _newPatients2.default
  }, {
    path: '/treatment',
    name: 'Treatment',
    navigation: true,
    component: _treatment2.default
  }, {
    path: '/accessibility',
    name: 'Accessibility',
    navigation: false,
    component: _accessibility2.default
  }, {
    path: '/welchorthodontics',
    name: 'Welch Orthodontics',
    navigation: false,
    component: _welchorthodontics2.default
  }, {
    path: '/reviews',
    name: 'Reviews',
    navigation: true,
    component: _reviews2.default
  }, {
    path: '/comfort-care',
    name: 'Comfort Care',
    navigation: true,
    component: _comfortCare2.default
  }, {
    path: '/contact',
    name: 'Contact',
    navigation: true,
    component: _contactUs2.default
  }, {
    path: '/*',
    name: 'page-not-found',
    navigation: false,
    component: _2.default
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 150 }
      };
    }
  }
});

router.beforeEach(function (to, from, next) {
  window.scrollTo(0, 0);
  next();
});

exports.default = router;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.relativePath = relativePath;
exports.formatPhone = formatPhone;
function relativePath(value) {
  var apiRoot = 'http://mastroianni.roostertest3.com';
  return value.replace(apiRoot, '');
}

function formatPhone(value) {
  return value.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
}

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(261);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _defineProperty2 = __webpack_require__(134);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = __webpack_require__(260);

var _extends5 = _interopRequireDefault(_extends4);

var _asyncToGenerator2 = __webpack_require__(259);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _axios = __webpack_require__(86);

var _axios2 = _interopRequireDefault(_axios);

var _api = __webpack_require__(64);

var _api2 = _interopRequireDefault(_api);

var _mutationTypes = __webpack_require__(133);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var actions = {
  GET_PAGES: function GET_PAGES(_ref) {
    var _this = this;

    var commit = _ref.commit;

    (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
      var response, data;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _axios2.default.get(_api2.default + '/wp/v2/pages?per_page=100');

            case 3:
              response = _context.sent;
              data = response.data.reduce(function (allData, data) {
                return (0, _extends5.default)({}, allData, (0, _defineProperty3.default)({}, data.slug, data));
              }, {});

              commit(_mutationTypes.GET_PAGES, data);
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context['catch'](0);

              console.log('PAGES API: ' + _context.t0);

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8]]);
    }))();
  },
  GET_APP: function GET_APP(_ref3) {
    var _this2 = this;

    var commit = _ref3.commit;

    (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
      var response, data;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _axios2.default.get(_api2.default + '/wp/v2/app');

            case 3:
              response = _context2.sent;
              data = response.data.reduce(function (allData, data) {
                return (0, _extends5.default)({}, allData, (0, _defineProperty3.default)({}, data.slug, data));
              }, {});

              commit(_mutationTypes.GET_APP, data);
              _context2.next = 11;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2['catch'](0);
              console.log('APP API: ' + _context2.t0);
            case 11:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 8]]);
    }))();
  },
  VIEW_NAV: function VIEW_NAV(_ref5, data) {
    var commit = _ref5.commit;

    commit(_mutationTypes.VIEW_NAV, data);
  },
  VIEW_BODY: function VIEW_BODY(_ref6, data) {
    var commit = _ref6.commit;

    commit(_mutationTypes.VIEW_BODY, data);
  },
  VIEW_TYPES: function VIEW_TYPES(_ref7, data) {
    var commit = _ref7.commit;

    commit(_mutationTypes.VIEW_TYPES, data);
  },
  VIEW_SHOWMODAL: function VIEW_SHOWMODAL(_ref8, data) {
    var commit = _ref8.commit;

    commit(_mutationTypes.VIEW_SHOWMODAL, data);
  },
  VIEW_MODALCONTENT: function VIEW_MODALCONTENT(_ref9, data) {
    var commit = _ref9.commit;

    commit(_mutationTypes.VIEW_MODALCONTENT, data);
  }
};

exports.default = actions;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(127);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(617);

var _vuex2 = _interopRequireDefault(_vuex);

var _mutations = __webpack_require__(208);

var _mutations2 = _interopRequireDefault(_mutations);

var _actions = __webpack_require__(206);

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var store = new _vuex2.default.Store({
  state: {
    app: {},
    pages: {},
    nav: {},

    body: {},
    types: {},
    showModal: {},
    modalContent: {},
    loading: true
  },
  mutations: _mutations2.default,
  actions: _actions2.default
});

exports.default = store;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(134);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

var _mutationTypes = __webpack_require__(133);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.GET_PAGES, function (state, data) {
  state.pages = data;
  state.loading = false;
}), (0, _defineProperty3.default)(_mutations, _mutationTypes.GET_APP, function (state, data) {
  state.app = data;
}), (0, _defineProperty3.default)(_mutations, _mutationTypes.VIEW_NAV, function (state, data) {
  state.nav = data;
}), (0, _defineProperty3.default)(_mutations, _mutationTypes.VIEW_BODY, function (state, data) {
  state.body = data;
}), (0, _defineProperty3.default)(_mutations, _mutationTypes.VIEW_TYPES, function (state, data) {
  state.types = data;
}), (0, _defineProperty3.default)(_mutations, _mutationTypes.VIEW_SHOWMODAL, function (state, data) {
  var body = document.getElementsByTagName('body')[0];
  data ? body.classList.add('open-modal') : body.classList.remove('open-modal');

  state.showModal = data;
}), (0, _defineProperty3.default)(_mutations, _mutationTypes.VIEW_MODALCONTENT, function (state, data) {
  state.modalContent = data;
}), _mutations);

exports.default = mutations;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _navigation = __webpack_require__(550);

var _navigation2 = _interopRequireDefault(_navigation);

var _footer = __webpack_require__(544);

var _footer2 = _interopRequireDefault(_footer);

var _revisions = __webpack_require__(564);

var _revisions2 = _interopRequireDefault(_revisions);

var _index = __webpack_require__(525);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  created: function created() {
    this.$store.dispatch('GET_PAGES');
    this.$store.dispatch('GET_APP');
    this.$store.dispatch('VIEW_NAV', false);
    this.$store.dispatch('VIEW_BODY', false);
    this.$store.dispatch('VIEW_TYPES', 0);
    this.$store.dispatch('VIEW_SHOWMODAL', false);
    this.$store.dispatch('VIEW_MODALCONTENT', false);
  },

  computed: {
    props: function props() {
      return this.$store.state;
    }
  },
  components: {
    Navigation: _navigation2.default,
    FooterMain: _footer2.default,
    Revisions: _revisions2.default,
    BaseBaseAccess: _index2.default
  },
  name: 'app'
};

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      companyName: 'Las Vegas Orthodontics',
      domain: "<a href='https://lvosmiles.com'>lvosmiles.com</a>",
      email: "<a href='mailto:info@LVOsmiles.com'>info@LVOsmiles.com</a>",
      phone: "<a href='tel:+17027354169'>702-735-4169</a>",
      formattedEmail: ''
    };
  }
};

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['props'],
  methods: {
    activate: function activate() {
      if (this.$store.state.showModal) {
        this.$store.dispatch('VIEW_SHOWMODAL', false);
      }
      this.$store.dispatch('VIEW_SHOWMODAL', true);
    }
  }
};

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['props']
};

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['props']
};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon = __webpack_require__(34);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['props'],
  components: {
    Icon: _icon2.default
  }
};

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['props']
};

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['props'],
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.$refs.fade.classList += ' custom-about-us-sections--fade';
    }, 10);
    setTimeout(function () {
      _this.$refs.slide.forEach(function (image, i) {
        image.classList += ' custom-about-us-sections__image--slide';
      });
    }, 100);
  }
};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['props']
};

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['props']
};

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['props'],
  methods: {
    activate: function activate() {
      if (this.$store.state.showModal) {
        this.$store.dispatch('VIEW_SHOWMODAL', false);
      }
      this.$store.dispatch('VIEW_SHOWMODAL', true);
    }
  }
};

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['props'],
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.$refs.fade.classList += ' custom-new-patients-first-visit--fade';
    }, 1);
    setTimeout(function () {
      _this.$refs.slide.classList += ' custom-new-patients-first-visit__image--slide';
    }, 10);
  }
};

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon = __webpack_require__(34);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['props'],
  components: {
    Icon: _icon2.default
  }
};

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['props'],
  data: function data() {
    return {
      yelper: 'unknown',
      location: 'unknown'
    };
  },

  methods: {
    isYelper: function isYelper(value) {
      this.yelper = value;
      console.log('yelper = ', this.yelper);
    },
    isLocation: function isLocation(value) {
      this.location = value;
      console.log('location = ', this.location);
    }
  }
};

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['props'],
  mounted: function mounted() {
    var _this = this;

    if (this.$route.hash === '#accelerated') {
      setTimeout(function () {
        _this.$scrollTo('#accelerated', { offset: -140 });
      }, 500);
    }
  }
};

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['props']
};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['props']
};

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['props'],
  data: function data() {
    return {
      active: 0
    };
  }
};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['props'],
  methods: {
    activate: function activate() {
      if (this.$store.state.showModal) {
        this.$store.dispatch('VIEW_SHOWMODAL', false);
      }
      this.$store.dispatch('VIEW_SHOWMODAL', true);
    }
  }
};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['props'],
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.$refs.fade.classList += ' custom-welch-sections--fade';
    }, 10);
    setTimeout(function () {
      _this.$refs.slide.forEach(function (image, i) {
        image.classList += ' custom-welch-sections__image--slide';
      });
    }, 100);
  }
};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['props']
};

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueParallaxy = __webpack_require__(612);

var _vueParallaxy2 = _interopRequireDefault(_vueParallaxy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['props', 'location'],
  components: {
    Parallax: _vueParallaxy2.default
  }
};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon = __webpack_require__(34);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  computed: {
    props: function props() {
      return this.$store.state.app;
    }
  },
  components: {
    Icon: _icon2.default
  }
};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(86);

var _axios2 = _interopRequireDefault(_axios);

var _api = __webpack_require__(64);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      first_last_name: '',
      phone_number: '',
      message: '',
      formSubmitted: false,
      postUrl: _api2.default + '/rg-mail/v1/contact'
    };
  },
  methods: {
    validateBeforeSubmit: function validateBeforeSubmit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.formSubmitted = true;
          _this.onSubmit();
        } else {
          console.log(result);
        }
      }).catch(function (e) {
        console.log(e);
      });
    },
    onSubmit: function onSubmit() {
      _axios2.default.post(this.postUrl, {
        name: this.first_last_name,
        phone: this.phone_number,
        message: this.message
      }).then(function (res) {
        console.log('sent');
      }).catch(function (e) {
        console.log(e);
      });
    }
  }
};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(86);

var _axios2 = _interopRequireDefault(_axios);

var _api = __webpack_require__(64);

var _api2 = _interopRequireDefault(_api);

var _icon = __webpack_require__(34);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      patient_name: '',
      new_patient: '',
      email: '',
      phone: '',
      selected: '',
      appointment_monday: '',
      appointment_tuesday: '',
      appointment_wednesday: '',
      appointment_thursday: '',
      appointment_friday: '',
      appointment_8am: '',
      appointment_11am: '',
      appointment_2pm: '',
      hear: '',
      message: '',
      formSubmitted: false,
      postUrl: _api2.default + '/rg-mail/v1/make-appointment'
    };
  },
  methods: {
    validateBeforeSubmit: function validateBeforeSubmit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.formSubmitted = true;
          _this.onSubmit();
        } else {
          console.log(result);
        }
      }).catch(function (e) {
        console.log(e);
      });
    },
    onSubmit: function onSubmit() {
      _axios2.default.post(this.postUrl, {
        patient_name: this.patient_name,
        new_patient: this.new_patient,
        email: this.email,
        phone: this.phone,
        selected: this.selected,
        appointment_monday: this.appointment_monday,
        appointment_tuesday: this.appointment_tuesday,
        appointment_wednesday: this.appointment_wednesday,
        appointment_thursday: this.appointment_thursday,
        appointment_friday: this.appointment_friday,
        appointment_8am: this.appointment_8am,
        appointment_11am: this.appointment_11am,
        appointment_2pm: this.appointment_2pm,
        hear: this.hear,
        message: this.message
      }).then(function (res) {
        console.log(res);
      }).catch(function (e) {
        console.log(e);
      });
    }
  },
  components: {
    BaseIcon: _icon2.default
  }
};

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['props'],
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.$refs.text.classList += ' hero__text--slide';
    }, 100);
  }
};

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['name'],
  computed: {
    svg: function svg() {
      return __webpack_require__(618)("./" + this.name + '.svg');
    }
  }
};

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  methods: {
    open: function open() {
      this.$store.state.showModal ? this.$store.dispatch('VIEW_SHOWMODAL', false) : this.$store.dispatch('VIEW_SHOWMODAL', true);
    }
  }
};

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _formMakeAppointment = __webpack_require__(546);

var _formMakeAppointment2 = _interopRequireDefault(_formMakeAppointment);

var _icon = __webpack_require__(34);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['props'],
  methods: {
    close: function close() {
      this.$store.dispatch('VIEW_SHOWMODAL', false);
    }
  },
  components: {
    Form: _formMakeAppointment2.default,
    Icon: _icon2.default
  }
};

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon = __webpack_require__(34);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['props'],
  methods: {
    activate: function activate() {
      if (this.$store.state.showModal) {
        this.$store.dispatch('VIEW_SHOWMODAL', false);
      }
      this.$store.dispatch('VIEW_SHOWMODAL', true);
    }
  },
  components: {
    Icon: _icon2.default
  }
};

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon = __webpack_require__(34);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['props'],
  data: function data() {
    return {
      active: false
    };
  },

  components: {
    Icon: _icon2.default
  }
};

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _navigationDesktop = __webpack_require__(548);

var _navigationDesktop2 = _interopRequireDefault(_navigationDesktop);

var _navigationMobile = __webpack_require__(549);

var _navigationMobile2 = _interopRequireDefault(_navigationMobile);

var _modal = __webpack_require__(126);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  computed: {
    props: function props() {
      return this.$router.options.routes;
    }
  },
  components: {
    Desktop: _navigationDesktop2.default,
    Mobile: _navigationMobile2.default,
    Modal: _modal2.default
  }
};

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueCarousel = __webpack_require__(63);

var _smallerArrowIcon = __webpack_require__(124);

var _smallerArrowIcon2 = _interopRequireDefault(_smallerArrowIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['props'],
  data: function data() {
    return {
      active: false,
      arrowNext: '<div class=\'slider-about-us-doctors__arrow slider-about-us-doctors__arrow--next\'>' + _smallerArrowIcon2.default + '</div>',
      arrowPrev: '<div class=\'slider-about-us-doctors__arrow slider-about-us-doctors__arrow--prev\'>' + _smallerArrowIcon2.default + '</div>'
    };
  },

  components: {
    Carousel: _vueCarousel.Carousel,
    Slide: _vueCarousel.Slide
  }
};

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueCarousel = __webpack_require__(63);

var _smallerArrowIcon = __webpack_require__(124);

var _smallerArrowIcon2 = _interopRequireDefault(_smallerArrowIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['props'],
  data: function data() {
    return {
      arrowNext: '<div class=\'slider-about-us-doctors__arrow slider-about-us-doctors__arrow--next\'>' + _smallerArrowIcon2.default + '</div>',
      arrowPrev: '<div class=\'slider-about-us-doctors__arrow slider-about-us-doctors__arrow--prev\'>' + _smallerArrowIcon2.default + '</div>'
    };
  },

  components: {
    Carousel: _vueCarousel.Carousel,
    Slide: _vueCarousel.Slide
  }
};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueCarousel = __webpack_require__(63);

var _icon = __webpack_require__(34);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['props'],
  components: {
    Carousel: _vueCarousel.Carousel,
    Slide: _vueCarousel.Slide,
    Icon: _icon2.default
  },
  methods: {
    SlideCarousel: function SlideCarousel(value) {
      var carousel = this.$refs['testimonial-carousel'];
      var currentPage = carousel.currentPage;
      var pageCount = carousel.pageCount;
      if (value === 'prev') {
        currentPage !== 0 ? carousel.goToPage(currentPage - 1) : carousel.goToPage(pageCount - 1);
      } else {
        currentPage < pageCount - 1 ? carousel.goToPage(currentPage + 1) : carousel.goToPage(0);
      }
    }
  }
};

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(35);

var _loader2 = _interopRequireDefault(_loader);

var _blockTitle = __webpack_require__(84);

var _blockTitle2 = _interopRequireDefault(_blockTitle);

var _customAboutUsSections = __webpack_require__(530);

var _customAboutUsSections2 = _interopRequireDefault(_customAboutUsSections);

var _sliderAboutUsDoctors = __webpack_require__(551);

var _sliderAboutUsDoctors2 = _interopRequireDefault(_sliderAboutUsDoctors);

var _sliderAboutUsTeam = __webpack_require__(552);

var _sliderAboutUsTeam2 = _interopRequireDefault(_sliderAboutUsTeam);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'about-us',
  computed: {
    props: function props() {
      return this.$store.state.pages['about-us'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  created: function created() {
    this.$store.dispatch('VIEW_NAV', true);
  },

  components: {
    Loader: _loader2.default,
    BlockTitle: _blockTitle2.default,
    CustomAboutUsSections: _customAboutUsSections2.default,
    SliderAboutUsDoctors: _sliderAboutUsDoctors2.default,
    SliderAboutUsTeam: _sliderAboutUsTeam2.default
  }
};

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(35);

var _loader2 = _interopRequireDefault(_loader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Accessibility',
  computed: {
    props: function props() {
      return this.$store.state.pages['about-us'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  created: function created() {
    this.$store.dispatch('VIEW_NAV', true);
  },

  components: {
    Loader: _loader2.default
  },
  data: function data() {
    return {
      companyName: 'Las Vegas Orthodontics',
      domain: "<a href='https://lvosmiles.com'>lvosmiles.com</a>",
      email: "<a href='mailto:info@LVOsmiles.com'>info@LVOsmiles.com</a>",
      phone: "<a href='tel:+17027354169'>702-735-4169</a>",
      formattedEmail: ''
    };
  },
  mounted: function mounted() {
    this.formatEmail();
  },

  methods: {
    formatEmail: function formatEmail() {
      this.formattedEmail = '<a aria-label="email ' + this.email + '" href="mailto:' + this.email + '">' + this.email + '</a>';
    }
  }
};

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(35);

var _loader2 = _interopRequireDefault(_loader);

var _customComfortCareSections = __webpack_require__(531);

var _customComfortCareSections2 = _interopRequireDefault(_customComfortCareSections);

var _blockSvgTitle = __webpack_require__(529);

var _blockSvgTitle2 = _interopRequireDefault(_blockSvgTitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'comfort-care',
  computed: {
    props: function props() {
      return this.$store.state.pages['comfort-care'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    BlockSvgTitle: _blockSvgTitle2.default,
    CustomComfortCareSections: _customComfortCareSections2.default
  }
};

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(35);

var _loader2 = _interopRequireDefault(_loader);

var _blockTitle = __webpack_require__(84);

var _blockTitle2 = _interopRequireDefault(_blockTitle);

var _formContact = __webpack_require__(545);

var _formContact2 = _interopRequireDefault(_formContact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'contact-us',
  computed: {
    props: function props() {
      return this.$store.state.pages['contact-us'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  created: function created() {
    this.$store.dispatch('VIEW_NAV', true);
  },

  components: {
    Loader: _loader2.default,
    BlockTitle: _blockTitle2.default,
    FormContact: _formContact2.default
  }
};

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(35);

var _loader2 = _interopRequireDefault(_loader);

var _modal = __webpack_require__(126);

var _modal2 = _interopRequireDefault(_modal);

var _hero = __webpack_require__(547);

var _hero2 = _interopRequireDefault(_hero);

var _blockIntro = __webpack_require__(527);

var _blockIntro2 = _interopRequireDefault(_blockIntro);

var _blockCtaModal = __webpack_require__(526);

var _blockCtaModal2 = _interopRequireDefault(_blockCtaModal);

var _dividerText = __webpack_require__(125);

var _dividerText2 = _interopRequireDefault(_dividerText);

var _customHomeTabs = __webpack_require__(532);

var _customHomeTabs2 = _interopRequireDefault(_customHomeTabs);

var _sliderTestimonials = __webpack_require__(553);

var _sliderTestimonials2 = _interopRequireDefault(_sliderTestimonials);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'home',
  computed: {
    props: function props() {
      return this.$store.state.pages.home;
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Modal: _modal2.default,
    Hero: _hero2.default,
    BlockIntro: _blockIntro2.default,
    BlockCtaModal: _blockCtaModal2.default,
    DividerText: _dividerText2.default,
    CustomHomeTabs: _customHomeTabs2.default,
    SliderTestimonials: _sliderTestimonials2.default
  },
  methods: {
    change: function change(direction, going) {
      if (going === 'out') {
        this.$store.dispatch('VIEW_NAV', true);
      }
      if (going === 'in' && direction.y === 'up') {
        this.$store.dispatch('VIEW_NAV', false);
      }
    }
  }
};

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(35);

var _loader2 = _interopRequireDefault(_loader);

var _modalContact = __webpack_require__(184);

var _modalContact2 = _interopRequireDefault(_modalContact);

var _customNewPatientsFirstVisit = __webpack_require__(534);

var _customNewPatientsFirstVisit2 = _interopRequireDefault(_customNewPatientsFirstVisit);

var _customNewPatientsConsultation = __webpack_require__(533);

var _customNewPatientsConsultation2 = _interopRequireDefault(_customNewPatientsConsultation);

var _customNewPatientsTabs = __webpack_require__(535);

var _customNewPatientsTabs2 = _interopRequireDefault(_customNewPatientsTabs);

var _dividerText = __webpack_require__(125);

var _dividerText2 = _interopRequireDefault(_dividerText);

var _blockParagraph = __webpack_require__(528);

var _blockParagraph2 = _interopRequireDefault(_blockParagraph);

var _dividerLogos = __webpack_require__(543);

var _dividerLogos2 = _interopRequireDefault(_dividerLogos);

var _modal = __webpack_require__(126);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'new-patients',
  computed: {
    props: function props() {
      return this.$store.state.pages['new-patients'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  created: function created() {
    this.$store.dispatch('VIEW_NAV', true);
  },

  components: {
    Loader: _loader2.default,
    ModalContact: _modalContact2.default,
    CustomNewPatientsFirstVisit: _customNewPatientsFirstVisit2.default,
    CustomNewPatientsConsultation: _customNewPatientsConsultation2.default,
    CustomNewPatientsTabs: _customNewPatientsTabs2.default,
    DividerText: _dividerText2.default,
    BlockParagraph: _blockParagraph2.default,
    DividerLogos: _dividerLogos2.default,
    Modal: _modal2.default
  }
};

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(35);

var _loader2 = _interopRequireDefault(_loader);

var _blockTitle = __webpack_require__(84);

var _blockTitle2 = _interopRequireDefault(_blockTitle);

var _customReviewsContent = __webpack_require__(536);

var _customReviewsContent2 = _interopRequireDefault(_customReviewsContent);

var _vueCarousel = __webpack_require__(63);

var _smallerArrowIcon = __webpack_require__(124);

var _smallerArrowIcon2 = _interopRequireDefault(_smallerArrowIcon);

var _icon = __webpack_require__(34);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'reviews',
  computed: {
    props: function props() {
      return this.$store.state.pages['reviews'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  created: function created() {
    this.$store.dispatch('VIEW_NAV', true);
  },
  data: function data() {
    return {
      active: false,
      arrowNext: '<div class=\'pages-reviews__arrow pages-reviews__arrow--next\'>' + _smallerArrowIcon2.default + '</div>',
      arrowPrev: '<div class=\'pages-reviews__arrow pages-reviews__arrow--prev\'>' + _smallerArrowIcon2.default + '</div>'
    };
  },

  components: {
    Loader: _loader2.default,
    BlockTitle: _blockTitle2.default,
    CustomReviewsContent: _customReviewsContent2.default,
    Carousel: _vueCarousel.Carousel,
    Slide: _vueCarousel.Slide,
    Icon: _icon2.default
  }
};

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(35);

var _loader2 = _interopRequireDefault(_loader);

var _modalContact = __webpack_require__(184);

var _modalContact2 = _interopRequireDefault(_modalContact);

var _blockTitle = __webpack_require__(84);

var _blockTitle2 = _interopRequireDefault(_blockTitle);

var _customTreatmentInvisalign = __webpack_require__(538);

var _customTreatmentInvisalign2 = _interopRequireDefault(_customTreatmentInvisalign);

var _customTreatmentTabs = __webpack_require__(540);

var _customTreatmentTabs2 = _interopRequireDefault(_customTreatmentTabs);

var _dividerText = __webpack_require__(125);

var _dividerText2 = _interopRequireDefault(_dividerText);

var _customTreatmentAcceleratedTreatments = __webpack_require__(537);

var _customTreatmentAcceleratedTreatments2 = _interopRequireDefault(_customTreatmentAcceleratedTreatments);

var _customTreatmentItero = __webpack_require__(539);

var _customTreatmentItero2 = _interopRequireDefault(_customTreatmentItero);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'treatment',
  computed: {
    props: function props() {
      return this.$store.state.pages.treatment;
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  created: function created() {
    this.$store.dispatch('VIEW_NAV', true);
  },

  components: {
    Loader: _loader2.default,
    ModalContact: _modalContact2.default,
    BlockTitle: _blockTitle2.default,
    CustomTreatmentInvisalign: _customTreatmentInvisalign2.default,
    CustomTreatmentTabs: _customTreatmentTabs2.default,
    DividerText: _dividerText2.default,
    CustomTreatmentAcceleratedTreatments: _customTreatmentAcceleratedTreatments2.default,
    CustomTreatmentItero: _customTreatmentItero2.default
  }
};

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(35);

var _loader2 = _interopRequireDefault(_loader);

var _customWelchConsultation = __webpack_require__(541);

var _customWelchConsultation2 = _interopRequireDefault(_customWelchConsultation);

var _customWelchSections = __webpack_require__(542);

var _customWelchSections2 = _interopRequireDefault(_customWelchSections);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Welch Orthodontics',
  computed: {
    props: function props() {
      return this.$store.state.pages['welchorthodontics'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  created: function created() {
    this.$store.dispatch('VIEW_NAV', true);
  },

  components: {
    Loader: _loader2.default,
    CustomWelchConsultation: _customWelchConsultation2.default,
    CustomWelchSections: _customWelchSections2.default
  }
};

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(64);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      dev: false,
      active: false
    };
  },
  created: function created() {
    _api2.default.indexOf('roostertest3') === -1 ? '' : this.dev = true;
  }
};

/***/ }),
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 15 15\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Triangle</title><desc>Created with Sketch.</desc><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\"><g id=\"About\" transform=\"translate(-67.000000, -3852.000000)\"><g id=\"Why-Gray\" transform=\"translate(0.000000, 3558.000000)\"><g id=\"Group-2\" transform=\"translate(67.000000, 260.000000)\"><polygon id=\"Triangle\" transform=\"translate(7.500000, 41.500000) scale(1, -1) translate(-7.500000, -41.500000) \" points=\"7.5 34 15 49 0 49\"></polygon></g></g></g></g></svg>"

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 56 19\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>arrow</title><desc>Created with Sketch.</desc><defs></defs><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"arrow\" fill=\"#30A4CD\"><path d=\"M47,6 L47,0 L56,9.5 L47,19 L47,13 L0,13 L0,6 L47,6 Z\"></path></g></g></svg>"

/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><defs><style>.a{fill:none;}</style></defs><title>calendar</title><path class=\"a\" d=\"M3.62,45.94a1.75,1.75,0,0,0,1.76,1.78H44.63a1.75,1.75,0,0,0,1.76-1.78h.05V17.7H3.62ZM14,29.69h7.8v-7.8h6.56v7.8h7.8v6.56h-7.8V44H21.76v-7.8H14Z\"></path><path d=\"M37,11.43a1.75,1.75,0,0,0,1.76-1.78V2.22a1.76,1.76,0,1,0-3.51,0V9.65A1.82,1.82,0,0,0,37,11.43Z\"></path><path d=\"M13.07,11.43a1.75,1.75,0,0,0,1.76-1.78V2.22a1.76,1.76,0,1,0-3.51,0V9.65A1.75,1.75,0,0,0,13.07,11.43Z\"></path><path d=\"M44.63,5H40.55V9.7a3.56,3.56,0,1,1-7.13,0V5H16.63V9.7a3.56,3.56,0,1,1-7.13,0V5H5.37A4.19,4.19,0,0,0,1.19,9.28V45.94a4.19,4.19,0,0,0,4.18,4.24H44.63a4.19,4.19,0,0,0,4.18-4.24V9.28A4.19,4.19,0,0,0,44.63,5Zm1.81,40.9h-.05a1.75,1.75,0,0,1-1.76,1.78H5.37a1.75,1.75,0,0,1-1.76-1.78V17.7H46.43Z\"></path><polygon points=\"21.76 44.05 28.32 44.05 28.32 36.25 36.12 36.25 36.12 29.68 28.32 29.68 28.32 21.89 21.76 21.89 21.76 29.68 13.96 29.68 13.96 36.25 21.76 36.25 21.76 44.05\"></polygon></svg>"

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 33 36\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Combined Shape</title><desc>Created with Sketch.</desc><defs></defs><g id=\"Final\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Make-an-Appointment\" transform=\"translate(-985.000000, -395.000000)\" fill=\"#30A4CD\"><path d=\"M1008.09839,413 L1018.05355,424.452094 L1010.53683,430.98627 L1001.5,420.590582 L992.463165,430.98627 L984.946455,424.452094 L994.901608,413 L984.946455,401.547906 L992.463165,395.01373 L1001.5,405.409418 L1010.53683,395.01373 L1018.05355,401.547906 L1008.09839,413 Z\" id=\"Combined-Shape\"></path></g></g></svg>"

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 1010 173.4\" style=\"enable-background:new 0 0 1010 173.4;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{opacity:0.15;fill:#30A4CD;enable-background:new ;} .st1{font-family:&#x27;FrankRuhlLibre-Regular&#x27;;} .st2{font-size:155px;} .st3{letter-spacing:9;} </style><text transform=\"matrix(1 0 0 1 0 128.6504)\" class=\"st0 st1 st2 st3\">Comfort Care</text></svg>"

/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 1629 279.7\" style=\"enable-background:new 0 0 1629 279.7;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{opacity:0.15;fill:#006F51;enable-background:new ;} .st1{font-family:&#x27;FrankRuhlLibre-Regular&#x27;;} .st2{font-size:250px;} .st3{letter-spacing:15;} </style><text transform=\"matrix(1 0 0 1 0 207.5)\" class=\"st0 st1 st2 st3\">Comfort Care</text></svg>"

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M28.2265 18.8912C27.0814 17.8187 25.5656 17.2313 23.9969 17.2522C22.6056 17.2634 21.2527 17.71 20.1281 18.5293C19.0035 19.3485 18.1637 20.4993 17.7265 21.8202L17.7264 21.8202C17.4968 22.5235 17.379 23.2585 17.3775 23.9984C17.3773 24.7275 17.4949 25.4517 17.7257 26.1431L17.737 26.1344C18.1708 27.4553 19.0084 28.6067 20.1315 29.4262C21.2545 30.2458 22.6065 30.6921 23.9968 30.7024C25.3479 30.7526 26.6814 30.3832 27.814 29.645L27.8428 29.6673C28.4259 29.2566 28.9215 28.7339 29.3006 28.1296C29.6859 27.5153 29.9428 26.8294 30.0559 26.1133H23.9969V21.9894H34.3384C34.5053 22.7282 34.5834 23.4843 34.571 24.2417C34.625 25.752 34.3601 27.2568 33.7934 28.6579C33.2268 30.059 32.3712 31.3249 31.2825 32.3731L31.257 32.3534C29.2632 34.1282 26.6658 35.0738 23.9968 34.9955C21.9554 34.9927 19.9552 34.4201 18.2216 33.3422C16.4957 32.2691 15.1022 30.7376 14.1963 28.9189L14.1736 28.9365C13.4019 27.4047 13 25.7135 13 23.9984C13 22.2833 13.4019 20.592 14.1736 19.0603L14.1736 19.0603C15.0868 17.2378 16.4895 15.7056 18.2245 14.6355C19.9596 13.5653 21.9584 12.9995 23.9969 13.0014C26.7412 12.9564 29.3955 13.9802 31.3987 15.8564L28.2265 18.8912Z\"></path><circle cx=\"24\" cy=\"24\" r=\"23.25\" stroke-width=\"1.5\"></circle></svg>"

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports = "<svg id=\"50e19e80-96cf-4ebb-9248-27a8d045a6a8\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 157.63 72.21\"><defs><style>.\\35 fdea26e-246e-4f71-b6c5-09fb700025ff,.e942960a-1aae-4a4a-844c-90edbf80e25e{fill:#fff;}.bff884b1-3016-4a8d-8918-607702d056c1{fill:#3e8ede;}.\\30 e98671a-d70f-434f-af3a-7f49eab5c09d{fill:#3fd5ae;}.\\35 fdea26e-246e-4f71-b6c5-09fb700025ff{isolation:isolate;font-size:62.79px;font-family:OpenSans-Light, Open Sans;}</style></defs><title>logo-active</title><rect class=\"e942960a-1aae-4a4a-844c-90edbf80e25e\" x=\"74.63\" width=\"60\" height=\"70\"></rect><path class=\"bff884b1-3016-4a8d-8918-607702d056c1\" d=\"M117.44,0h33.73a6.39,6.39,0,0,1,6.43,6.35h0V63.64A6.39,6.39,0,0,1,151.21,70H103.95q1.32-.59,2.65-1.34a39.22,39.22,0,0,0,6-4.21,50.12,50.12,0,0,0,5.64-5.6h0a41.77,41.77,0,0,0,5-7.29h0a60.92,60.92,0,0,0,4-9.17,61.76,61.76,0,0,0,2.64-10.59,72.89,72.89,0,0,0,.88-11.47q0-1.51-.09-3c-.06-1-.16-1.93-.28-2.88s-.28-1.89-.48-2.84-.42-1.9-.68-2.86h0a12.45,12.45,0,0,0-1-2.64A9.3,9.3,0,0,0,126.71,4a6.11,6.11,0,0,0-1.93-1.38,5.55,5.55,0,0,0-2.26-.46,10.28,10.28,0,0,0-5.22,1.66,28.34,28.34,0,0,0-5.78,4.85,29.43,29.43,0,0,0-4.63,6.06,11.56,11.56,0,0,0-1.57,5.45,4.3,4.3,0,0,0,1.28,3.22h0a7.22,7.22,0,0,0,3.59,1.74l.46.1.1-.46a35.27,35.27,0,0,1,1.94-6,55,55,0,0,1,3.3-6.53h0a23.49,23.49,0,0,1,3.71-5,4.65,4.65,0,0,1,3-1.58,1.85,1.85,0,0,1,1.46.81h0a7.73,7.73,0,0,1,1.21,2.8h0a34.45,34.45,0,0,1,1,8.5,68.94,68.94,0,0,1-.92,11.1,80.79,80.79,0,0,1-2.75,11.4A62.37,62.37,0,0,1,118.22,51a52.47,52.47,0,0,1-6.13,9.05,25.61,25.61,0,0,1-7.17,6.11,15.85,15.85,0,0,1-7.68,2,10.48,10.48,0,0,1-5.17-1.23h0a9.89,9.89,0,0,1-3.67-3.69h0a19.92,19.92,0,0,1-2.26-5.71,31.17,31.17,0,0,1-.75-7.13,45.15,45.15,0,0,1,.8-8.3,59.12,59.12,0,0,1,2.41-8.81,80.48,80.48,0,0,1,3.61-8.65,71.81,71.81,0,0,1,4.39-7.83,54,54,0,0,1,5.19-6.72,45.92,45.92,0,0,1,5.9-5.46A26.07,26.07,0,0,1,113.74,1,16.32,16.32,0,0,1,117.44,0Z\" transform=\"translate(0.03 0)\"></path><path class=\"0e98671a-d70f-434f-af3a-7f49eab5c09d\" d=\"M6.39,0H106a32,32,0,0,0-4.41,2.59h0A49.15,49.15,0,0,0,95.11,8a55.72,55.72,0,0,0-5.75,6.63,61.75,61.75,0,0,0-4.9,7.77,73,73,0,0,0-3.94,8.79h0a57.8,57.8,0,0,0-2.59,9.15,46.62,46.62,0,0,0-.87,8.82,34,34,0,0,0,1.19,9.33,22.09,22.09,0,0,0,3.59,7.35A16.59,16.59,0,0,0,86.36,70h-80A6.39,6.39,0,0,1,0,63.64V6.36A6.39,6.39,0,0,1,6.39,0Z\" transform=\"translate(0.03 0)\"></path><path class=\"e942960a-1aae-4a4a-844c-90edbf80e25e\" d=\"M114.32,41.33c.36,23.78-32.16,25.65-21,2.65l.43-.19c-8,20,17.83,15.81,20.29-2.76Z\" transform=\"translate(0.03 0)\"></path><text class=\"5fdea26e-246e-4f71-b6c5-09fb700025ff\" transform=\"translate(8.92 55.32)\">L</text><text class=\"5fdea26e-246e-4f71-b6c5-09fb700025ff\" transform=\"translate(35.45 55.32)\">V</text></svg>"

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports = "<svg id=\"f453cedf-61a7-476c-ac4b-98aa05646b62\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 157.6 85.57\"><defs><style>.\\32 4930396-02dc-4e6f-9618-e07b93128421{fill:#fff;}.cff120e4-3a03-4887-84dc-710139cd581f{fill:#3e8ede;}.fce276cd-ecee-4765-98e4-29b847f8746a{fill:#3fd5ae;}</style></defs><title>logo-footer</title><path class=\"24930396-02dc-4e6f-9618-e07b93128421\" d=\"M112.63,64.45a50.12,50.12,0,0,0,5.64-5.6,41.77,41.77,0,0,0,5-7.29,60.91,60.91,0,0,0,4-9.17,61.76,61.76,0,0,0,2.64-10.59,72.9,72.9,0,0,0,.88-11.47q0-1.51-.09-3c-.06-1-.16-1.93-.28-2.88s-.28-1.89-.48-2.84-.42-1.9-.68-2.86a12.45,12.45,0,0,0-1-2.64A9.3,9.3,0,0,0,126.74,4a6.11,6.11,0,0,0-1.93-1.38,5.55,5.55,0,0,0-2.26-.46,10.28,10.28,0,0,0-5.22,1.66,28.34,28.34,0,0,0-5.78,4.85,29.43,29.43,0,0,0-4.63,6.06,11.56,11.56,0,0,0-1.57,5.45,4.3,4.3,0,0,0,1.28,3.22,7.22,7.22,0,0,0,3.59,1.74l.46.1.1-.46a35.27,35.27,0,0,1,1.94-6,55,55,0,0,1,3.3-6.53,23.49,23.49,0,0,1,3.71-5,4.65,4.65,0,0,1,3-1.58,1.85,1.85,0,0,1,1.46.81,7.73,7.73,0,0,1,1.21,2.8,34.45,34.45,0,0,1,1,8.5,68.94,68.94,0,0,1-.92,11.1,80.78,80.78,0,0,1-2.75,11.4A62.36,62.36,0,0,1,118.25,51a52.47,52.47,0,0,1-6.13,9A25.61,25.61,0,0,1,105,66.11a15.85,15.85,0,0,1-7.68,2,10.48,10.48,0,0,1-5.17-1.23,9.89,9.89,0,0,1-3.67-3.69,19.92,19.92,0,0,1-2.26-5.71,31.17,31.17,0,0,1-.75-7.13,45.15,45.15,0,0,1,.8-8.3,59.11,59.11,0,0,1,2.41-8.81,80.48,80.48,0,0,1,3.61-8.65,71.81,71.81,0,0,1,4.39-7.83A54,54,0,0,1,101.82,10a45.92,45.92,0,0,1,5.9-5.46,26.07,26.07,0,0,1,6-3.59,16.32,16.32,0,0,1,3.7-1H106a32,32,0,0,0-4.41,2.59A49.15,49.15,0,0,0,95.14,8a55.72,55.72,0,0,0-5.75,6.63,61.75,61.75,0,0,0-4.9,7.77,73,73,0,0,0-3.94,8.79A57.8,57.8,0,0,0,78,40.34a46.63,46.63,0,0,0-.87,8.82,34,34,0,0,0,1.19,9.33,22.09,22.09,0,0,0,3.59,7.35A16.59,16.59,0,0,0,86.39,70H104q1.32-.59,2.65-1.34A39.22,39.22,0,0,0,112.63,64.45Z\" transform=\"translate(-0.03 0.01)\"></path><path class=\"cff120e4-3a03-4887-84dc-710139cd581f\" d=\"M157.63,6.35A6.39,6.39,0,0,0,151.2,0H117.47a16.32,16.32,0,0,0-3.7,1,26.07,26.07,0,0,0-6,3.59,45.92,45.92,0,0,0-5.9,5.46,54,54,0,0,0-5.19,6.72,71.81,71.81,0,0,0-4.39,7.83,80.48,80.48,0,0,0-3.61,8.65,59.11,59.11,0,0,0-2.41,8.81,45.15,45.15,0,0,0-.8,8.3,31.17,31.17,0,0,0,.75,7.13,19.92,19.92,0,0,0,2.26,5.71,9.89,9.89,0,0,0,3.67,3.69,10.48,10.48,0,0,0,5.17,1.23,15.85,15.85,0,0,0,7.68-2A25.61,25.61,0,0,0,112.12,60a52.47,52.47,0,0,0,6.13-9,62.36,62.36,0,0,0,4.48-10.7,80.78,80.78,0,0,0,2.75-11.4,68.94,68.94,0,0,0,.92-11.1,34.45,34.45,0,0,0-1-8.5,7.73,7.73,0,0,0-1.21-2.8,1.85,1.85,0,0,0-1.46-.81,4.65,4.65,0,0,0-3,1.58,23.49,23.49,0,0,0-3.71,5,55,55,0,0,0-3.3,6.53,35.27,35.27,0,0,0-1.94,6l-.1.46-.46-.1a7.22,7.22,0,0,1-3.59-1.74,4.3,4.3,0,0,1-1.28-3.22,11.56,11.56,0,0,1,1.57-5.45,29.43,29.43,0,0,1,4.63-6.06,28.34,28.34,0,0,1,5.78-4.85,10.28,10.28,0,0,1,5.22-1.66,5.55,5.55,0,0,1,2.26.46A6.11,6.11,0,0,1,126.74,4a9.3,9.3,0,0,1,1.52,2.09,12.45,12.45,0,0,1,1,2.64c.26,1,.48,1.91.68,2.86s.36,1.89.48,2.84.22,1.88.28,2.88.09,2,.09,3a72.9,72.9,0,0,1-.88,11.47,61.76,61.76,0,0,1-2.64,10.59,60.91,60.91,0,0,1-4,9.17,41.77,41.77,0,0,1-5,7.29,50.12,50.12,0,0,1-5.64,5.6,39.22,39.22,0,0,1-6,4.21Q105.3,69.39,104,70h47.26a6.39,6.39,0,0,0,6.39-6.36V6.36ZM114,41l.28.3c.36,23.78-32.16,25.65-21,2.65l.43-.19C85.78,63.79,111.61,59.6,114,41Z\" transform=\"translate(-0.03 0.01)\"></path><path class=\"fce276cd-ecee-4765-98e4-29b847f8746a\" d=\"M81.87,65.8a22.09,22.09,0,0,1-3.59-7.35,34,34,0,0,1-1.19-9.33A46.63,46.63,0,0,1,78,40.3a57.8,57.8,0,0,1,2.59-9.15,73,73,0,0,1,3.94-8.79,61.75,61.75,0,0,1,4.9-7.77A55.72,55.72,0,0,1,95.14,8a49.15,49.15,0,0,1,6.49-5.37A32,32,0,0,1,106,0H6.42A6.39,6.39,0,0,0,0,6.36V63.64A6.39,6.39,0,0,0,6.39,70h80A16.59,16.59,0,0,1,81.87,65.8ZM38.93,55.32H14.51v-44h3.14V52.43H38.93Zm18.1.31H54.1L37.9,11.37h3.39l14.32,40L70,11.37h3.26Z\" transform=\"translate(-0.03 0.01)\"></path><path class=\"24930396-02dc-4e6f-9618-e07b93128421\" d=\"M93.78,43.79l-.43.19c-11.16,23,21.36,21.13,21-2.65L114,41C111.61,59.6,85.78,63.79,93.78,43.79Z\" transform=\"translate(-0.03 0.01)\"></path><polygon class=\"24930396-02dc-4e6f-9618-e07b93128421\" points=\"17.62 11.38 14.48 11.38 14.48 55.33 38.9 55.33 38.9 52.44 17.62 52.44 17.62 11.38\"></polygon><polygon class=\"24930396-02dc-4e6f-9618-e07b93128421\" points=\"55.58 51.37 41.26 11.38 37.87 11.38 54.07 55.64 56.96 55.64 73.22 11.38 69.95 11.38 55.58 51.37\"></polygon><path class=\"24930396-02dc-4e6f-9618-e07b93128421\" d=\"M2.75,76.79h.93v7.75h4v.85H2.75Z\" transform=\"translate(-0.03 0.01)\"></path><path class=\"24930396-02dc-4e6f-9618-e07b93128421\" d=\"M11.76,76.73h.91l3.28,8.66h-1l-.84-2.26H10.27l-.84,2.26H8.49Zm2.06,5.56L12.2,77.93l-1.63,4.36Z\" transform=\"translate(-0.03 0.01)\"></path><path class=\"24930396-02dc-4e6f-9618-e07b93128421\" d=\"M16.7,84.3l.58-.7a3.44,3.44,0,0,0,2.42,1.07,1.55,1.55,0,0,0,1.72-1.36v-.08h0c0-.71-.36-1.17-1.92-1.72C17.74,80.82,17,80.18,17,79h0a2.37,2.37,0,0,1,2.46-2.28h.12a3.76,3.76,0,0,1,2.58,1l-.55.72a3,3,0,0,0-2.06-.85A1.45,1.45,0,0,0,18,78.87v.07h0c0,.75.38,1.18,2,1.77s2.37,1.35,2.37,2.49h0a2.42,2.42,0,0,1-2.48,2.36h-.17A4.24,4.24,0,0,1,16.7,84.3Z\" transform=\"translate(-0.03 0.01)\"></path><path class=\"24930396-02dc-4e6f-9618-e07b93128421\" d=\"M26.25,76.79h1l2.53,7.31,2.54-7.31h1l-3.11,8.66h-.86Z\" transform=\"translate(-0.03 0.01)\"></path><path class=\"24930396-02dc-4e6f-9618-e07b93128421\" d=\"M34.74,76.79H40v.85H35.66v3h3.88v.85H35.66v3.06H40v.85H34.74Z\" transform=\"translate(-0.03 0.01)\"></path><path class=\"24930396-02dc-4e6f-9618-e07b93128421\" d=\"M41.33,81.14v-.09c0-2.49,1.58-4.38,3.82-4.38a3.8,3.8,0,0,1,2.62.92l-.56.74a2.88,2.88,0,0,0-2.06-.8C43.52,77.53,42.3,79,42.3,81v.07c0,2.16,1.17,3.56,2.94,3.56A3.1,3.1,0,0,0,47,84.06V81.64H44.92V80.8H48v3.7a4.51,4.51,0,0,1-2.8,1C42.84,85.51,41.33,83.73,41.33,81.14Z\" transform=\"translate(-0.03 0.01)\"></path><path class=\"24930396-02dc-4e6f-9618-e07b93128421\" d=\"M52.51,76.73h.91l3.28,8.66h-1l-.84-2.26H51l-.84,2.26h-1Zm2.06,5.56L53,77.93l-1.63,4.36Z\" transform=\"translate(-0.03 0.01)\"></path><path class=\"24930396-02dc-4e6f-9618-e07b93128421\" d=\"M57.44,84.3l.58-.7a3.44,3.44,0,0,0,2.42,1.07,1.55,1.55,0,0,0,1.72-1.36v-.08h0c0-.71-.36-1.17-1.92-1.72-1.78-.66-2.47-1.3-2.47-2.52h0a2.37,2.37,0,0,1,2.46-2.28h.12a3.76,3.76,0,0,1,2.58,1l-.55.72a3,3,0,0,0-2.06-.85,1.45,1.45,0,0,0-1.61,1.27v.07h0c0,.75.38,1.18,2,1.77s2.37,1.35,2.37,2.49h0a2.42,2.42,0,0,1-2.48,2.36h-.17A4.24,4.24,0,0,1,57.44,84.3Z\" transform=\"translate(-0.03 0.01)\"></path><path class=\"24930396-02dc-4e6f-9618-e07b93128421\" d=\"M67.28,81.15V81c0-2.52,1.52-4.38,3.71-4.38s3.69,1.85,3.69,4.37v.11c0,2.52-1.5,4.38-3.7,4.38S67.28,83.67,67.28,81.15Zm6.44,0v-.09c0-2.08-1.17-3.55-2.74-3.55S68.24,79,68.24,81v.09c0,2.08,1.17,3.55,2.75,3.55s2.73-1.42,2.73-3.5Z\" transform=\"translate(-0.03 0.01)\"></path><path class=\"24930396-02dc-4e6f-9618-e07b93128421\" d=\"M76.41,76.79h2.95a3.1,3.1,0,0,1,2.25.8,2.47,2.47,0,0,1,.68,1.77h0a2.43,2.43,0,0,1-2,2.47l2.28,3.54H81.45L79.29,82H77.35v3.34h-.93Zm2.78,4.42c1.4,0,2.17-.7,2.17-1.79h0c0-1.13-.77-1.76-2.08-1.76H77.35v3.57Z\" transform=\"translate(-0.03 0.01)\"></path><path class=\"24930396-02dc-4e6f-9618-e07b93128421\" d=\"M85.82,77.65H83.41v-.86h5.76v.86H86.75v7.74h-.92Z\" transform=\"translate(-0.03 0.01)\"></path><path class=\"24930396-02dc-4e6f-9618-e07b93128421\" d=\"M90.65,76.79h.93v3.84h4.14V76.79h.92v8.6h-.92V81.5H91.58v3.89h-.93Z\" transform=\"translate(-0.03 0.01)\"></path><path class=\"24930396-02dc-4e6f-9618-e07b93128421\" d=\"M98.37,81.15V81c0-2.52,1.52-4.38,3.71-4.38s3.68,1.85,3.68,4.37v.11c0,2.52-1.5,4.38-3.7,4.38S98.37,83.67,98.37,81.15Zm6.44,0v-.09c0-2.08-1.17-3.55-2.74-3.55S99.33,79,99.33,81v.09c0,2.08,1.17,3.55,2.75,3.55s2.73-1.42,2.73-3.5Z\" transform=\"translate(-0.03 0.01)\"></path><path class=\"24930396-02dc-4e6f-9618-e07b93128421\" d=\"M107.5,76.79h2.42a4,4,0,0,1,4,4q0,.13,0,.26v.09a4,4,0,0,1-3.73,4.25H107.5Zm.93.85v6.9h1.47a3.08,3.08,0,0,0,3.11-3.4v-.09a3.09,3.09,0,0,0-2.74-3.4l-.37,0Z\" transform=\"translate(-0.03 0.01)\"></path><path class=\"24930396-02dc-4e6f-9618-e07b93128421\" d=\"M115.36,81.15V81c0-2.52,1.52-4.38,3.71-4.38s3.69,1.85,3.69,4.37v.11c0,2.52-1.5,4.38-3.7,4.38S115.36,83.67,115.36,81.15Zm6.44,0v-.09c0-2.08-1.17-3.55-2.74-3.55S116.32,79,116.32,81v.09c0,2.08,1.17,3.55,2.75,3.55s2.72-1.42,2.72-3.5Z\" transform=\"translate(-0.03 0.01)\"></path><path class=\"24930396-02dc-4e6f-9618-e07b93128421\" d=\"M124.48,76.79h.87l4.5,6.76V76.79h.91v8.6H130l-4.61-6.94v6.94h-.9Z\" transform=\"translate(-0.03 0.01)\"></path><path class=\"24930396-02dc-4e6f-9618-e07b93128421\" d=\"M134.66,77.65h-2.42v-.86H138v.86h-2.42v7.74h-.92Z\" transform=\"translate(-0.03 0.01)\"></path><path class=\"24930396-02dc-4e6f-9618-e07b93128421\" d=\"M139.56,76.79h.93v8.6h-.93Z\" transform=\"translate(-0.03 0.01)\"></path><path class=\"24930396-02dc-4e6f-9618-e07b93128421\" d=\"M142.3,81.14v-.09c0-2.59,1.62-4.38,3.77-4.38a3.62,3.62,0,0,1,2.63,1.07l-.58.71a2.9,2.9,0,0,0-2.09-.92c-1.57,0-2.78,1.45-2.78,3.53h0c0,2.11,1.22,3.55,2.79,3.55a2.86,2.86,0,0,0,2.13-1l.56.66a3.68,3.68,0,0,1-2.7,1.24C143.87,85.51,142.3,83.77,142.3,81.14Z\" transform=\"translate(-0.03 0.01)\"></path><path class=\"24930396-02dc-4e6f-9618-e07b93128421\" d=\"M149.61,84.3l.58-.7a3.44,3.44,0,0,0,2.42,1.07,1.55,1.55,0,0,0,1.72-1.36v-.08h0c0-.71-.36-1.17-1.92-1.72-1.78-.66-2.47-1.3-2.47-2.52h0a2.37,2.37,0,0,1,2.46-2.28h.12a3.75,3.75,0,0,1,2.58,1l-.55.72a3,3,0,0,0-2.06-.85,1.45,1.45,0,0,0-1.61,1.27v.07h0c0,.75.38,1.18,2,1.77s2.37,1.35,2.37,2.49h0a2.42,2.42,0,0,1-2.48,2.36h-.17A4.24,4.24,0,0,1,149.61,84.3Z\" transform=\"translate(-0.03 0.01)\"></path></svg>"

/***/ }),
/* 518 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 157.63 85.52\"><defs><style>.a{fill:#fff;}.b{fill:#3e8ede;}.c{fill:#3fd5ae;}.d{isolation:isolate;}</style></defs><title>LVO_logo-trial2</title><path class=\"a\" d=\"M112.6,64.45a50.12,50.12,0,0,0,5.64-5.6,41.77,41.77,0,0,0,5-7.29,60.91,60.91,0,0,0,4-9.17,61.76,61.76,0,0,0,2.64-10.59,72.9,72.9,0,0,0,.88-11.47q0-1.51-.09-3c-.06-1-.16-1.93-.28-2.88s-.28-1.89-.48-2.84-.42-1.9-.68-2.86a12.45,12.45,0,0,0-1-2.64A9.3,9.3,0,0,0,126.71,4a6.11,6.11,0,0,0-1.93-1.38,5.55,5.55,0,0,0-2.26-.46,10.28,10.28,0,0,0-5.22,1.66,28.34,28.34,0,0,0-5.78,4.85,29.43,29.43,0,0,0-4.63,6.06,11.56,11.56,0,0,0-1.57,5.45,4.3,4.3,0,0,0,1.28,3.22,7.22,7.22,0,0,0,3.59,1.74l.46.1.1-.46a35.27,35.27,0,0,1,1.94-6,55,55,0,0,1,3.3-6.53,23.49,23.49,0,0,1,3.71-5,4.65,4.65,0,0,1,3-1.58,1.85,1.85,0,0,1,1.46.81,7.73,7.73,0,0,1,1.21,2.8,34.45,34.45,0,0,1,1,8.5,68.94,68.94,0,0,1-.92,11.1,80.78,80.78,0,0,1-2.75,11.4A62.36,62.36,0,0,1,118.22,51a52.47,52.47,0,0,1-6.13,9,25.61,25.61,0,0,1-7.17,6.11,15.85,15.85,0,0,1-7.68,2,10.48,10.48,0,0,1-5.17-1.23,9.89,9.89,0,0,1-3.67-3.69,19.92,19.92,0,0,1-2.26-5.71,31.17,31.17,0,0,1-.75-7.13,45.15,45.15,0,0,1,.8-8.3,59.11,59.11,0,0,1,2.41-8.81,80.48,80.48,0,0,1,3.61-8.65,71.81,71.81,0,0,1,4.39-7.83,54,54,0,0,1,5.19-6.72,45.92,45.92,0,0,1,5.9-5.46,26.07,26.07,0,0,1,6-3.59,16.32,16.32,0,0,1,3.7-1H106a32,32,0,0,0-4.41,2.59A49.15,49.15,0,0,0,95.11,8a55.72,55.72,0,0,0-5.75,6.63,61.75,61.75,0,0,0-4.9,7.77,73,73,0,0,0-3.94,8.79,57.8,57.8,0,0,0-2.59,9.15,46.63,46.63,0,0,0-.87,8.82,34,34,0,0,0,1.19,9.33,22.09,22.09,0,0,0,3.59,7.35A16.59,16.59,0,0,0,86.36,70H104q1.32-.59,2.65-1.34A39.22,39.22,0,0,0,112.6,64.45Z\" transform=\"translate(0.03 0)\"></path><path class=\"b\" d=\"M157.6,6.35A6.39,6.39,0,0,0,151.17,0H117.44a16.32,16.32,0,0,0-3.7,1,26.07,26.07,0,0,0-6,3.59,45.92,45.92,0,0,0-5.9,5.46,54,54,0,0,0-5.19,6.72,71.81,71.81,0,0,0-4.39,7.83,80.48,80.48,0,0,0-3.61,8.65,59.11,59.11,0,0,0-2.41,8.81,45.15,45.15,0,0,0-.8,8.3,31.17,31.17,0,0,0,.75,7.13,19.92,19.92,0,0,0,2.26,5.71,9.89,9.89,0,0,0,3.67,3.69,10.48,10.48,0,0,0,5.17,1.23,15.85,15.85,0,0,0,7.68-2A25.61,25.61,0,0,0,112.09,60a52.47,52.47,0,0,0,6.13-9,62.36,62.36,0,0,0,4.48-10.7,80.78,80.78,0,0,0,2.75-11.4,68.94,68.94,0,0,0,.92-11.1,34.45,34.45,0,0,0-1-8.5,7.73,7.73,0,0,0-1.21-2.8,1.85,1.85,0,0,0-1.46-.81,4.65,4.65,0,0,0-3,1.58,23.49,23.49,0,0,0-3.71,5,55,55,0,0,0-3.3,6.53,35.27,35.27,0,0,0-1.94,6l-.1.46-.46-.1a7.22,7.22,0,0,1-3.59-1.74,4.3,4.3,0,0,1-1.28-3.22,11.56,11.56,0,0,1,1.57-5.45,29.43,29.43,0,0,1,4.63-6.06,28.34,28.34,0,0,1,5.78-4.85,10.28,10.28,0,0,1,5.22-1.66,5.55,5.55,0,0,1,2.26.46A6.11,6.11,0,0,1,126.71,4a9.3,9.3,0,0,1,1.52,2.09,12.45,12.45,0,0,1,1,2.64c.26,1,.48,1.91.68,2.86s.36,1.89.48,2.84.22,1.88.28,2.88.09,2,.09,3a72.9,72.9,0,0,1-.88,11.47,61.76,61.76,0,0,1-2.64,10.59,60.91,60.91,0,0,1-4,9.17,41.77,41.77,0,0,1-5,7.29,50.12,50.12,0,0,1-5.64,5.6,39.22,39.22,0,0,1-6,4.21q-1.33.75-2.65,1.34h47.26a6.39,6.39,0,0,0,6.39-6.36V6.36ZM114,41l.28.3c.36,23.78-32.16,25.65-21,2.65l.43-.19C85.75,63.79,111.58,59.6,114,41Z\" transform=\"translate(0.03 0)\"></path><path class=\"c\" d=\"M81.84,65.8a22.09,22.09,0,0,1-3.59-7.35,34,34,0,0,1-1.19-9.33,46.63,46.63,0,0,1,.87-8.82,57.8,57.8,0,0,1,2.59-9.15,73,73,0,0,1,3.94-8.79,61.75,61.75,0,0,1,4.9-7.77A55.72,55.72,0,0,1,95.11,8a49.15,49.15,0,0,1,6.49-5.37A32,32,0,0,1,106,0H6.39A6.39,6.39,0,0,0,0,6.36V63.64A6.39,6.39,0,0,0,6.36,70h80A16.59,16.59,0,0,1,81.84,65.8ZM38.9,55.32H14.48v-44h3.14V52.43H38.9ZM57,55.63H54.07L37.87,11.37h3.39l14.32,40L70,11.37h3.26Z\" transform=\"translate(0.03 0)\"></path><path class=\"a\" d=\"M93.75,43.79l-.43.19c-11.16,23,21.36,21.13,21-2.65L114,41C111.58,59.6,85.75,63.79,93.75,43.79Z\" transform=\"translate(0.03 0)\"></path><polygon class=\"a\" points=\"17.65 11.37 14.51 11.37 14.51 55.32 38.93 55.32 38.93 52.43 17.65 52.43 17.65 11.37\"></polygon><polygon class=\"a\" points=\"55.61 51.36 41.29 11.37 37.9 11.37 54.1 55.63 56.99 55.63 73.25 11.37 69.98 11.37 55.61 51.36\"></polygon><g class=\"d\"><g class=\"d\"><path class=\"b\" d=\"M2.72,76.79h.93v7.75h4v.85H2.72Z\" transform=\"translate(0.03 0)\"></path></g><g class=\"d\"><path class=\"b\" d=\"M11.73,76.73h.91l3.28,8.66h-1l-.84-2.26H10.24L9.4,85.39H8.46Zm2.06,5.56-1.62-4.36-1.63,4.36Z\" transform=\"translate(0.03 0)\"></path></g><path class=\"b\" d=\"M16.67,84.3l.58-.7a3.44,3.44,0,0,0,2.42,1.07,1.55,1.55,0,0,0,1.73-1.44v0c0-.71-.36-1.17-1.92-1.72C17.71,80.82,17,80.18,17,79v0a2.37,2.37,0,0,1,2.58-2.27,3.76,3.76,0,0,1,2.58,1l-.55.72a3,3,0,0,0-2.06-.85,1.45,1.45,0,0,0-1.62,1.34v0c0,.75.38,1.18,2,1.77s2.37,1.35,2.37,2.49v0a2.42,2.42,0,0,1-2.65,2.35A4.24,4.24,0,0,1,16.67,84.3Z\" transform=\"translate(0.03 0)\"></path><path class=\"b\" d=\"M26.22,76.79h1l2.53,7.31,2.54-7.31h1l-3.11,8.66h-.86Z\" transform=\"translate(0.03 0)\"></path><g class=\"d\"><path class=\"b\" d=\"M34.71,76.79H40v.85H35.63v3h3.88v.85H35.63v3.06H40v.85H34.71Z\" transform=\"translate(0.03 0)\"></path></g><g class=\"d\"><path class=\"b\" d=\"M41.3,81.14v-.09c0-2.49,1.58-4.38,3.82-4.38a3.8,3.8,0,0,1,2.62.92l-.56.74a2.88,2.88,0,0,0-2.06-.8c-1.63,0-2.85,1.47-2.85,3.51v.07c0,2.16,1.17,3.56,2.94,3.56A3.1,3.1,0,0,0,47,84.06V81.64H44.89v-.84h3.06v3.7a4.51,4.51,0,0,1-2.8,1C42.81,85.51,41.3,83.73,41.3,81.14Z\" transform=\"translate(0.03 0)\"></path></g><g class=\"d\"><path class=\"b\" d=\"M52.48,76.73h.91l3.28,8.66h-1l-.84-2.26H51l-.84,2.26H49.2Zm2.06,5.56-1.62-4.36-1.63,4.36Z\" transform=\"translate(0.03 0)\"></path></g><g class=\"d\"><path class=\"b\" d=\"M57.41,84.3l.58-.7a3.44,3.44,0,0,0,2.42,1.07,1.55,1.55,0,0,0,1.73-1.44v0c0-.71-.36-1.17-1.92-1.72-1.78-.66-2.47-1.3-2.47-2.52v0a2.37,2.37,0,0,1,2.58-2.27,3.76,3.76,0,0,1,2.58,1l-.55.72a3,3,0,0,0-2.06-.85,1.45,1.45,0,0,0-1.62,1.34v0c0,.75.38,1.18,2,1.77s2.37,1.35,2.37,2.49v0a2.42,2.42,0,0,1-2.65,2.35A4.24,4.24,0,0,1,57.41,84.3Z\" transform=\"translate(0.03 0)\"></path><path class=\"b\" d=\"M67.25,81.15V81c0-2.52,1.52-4.38,3.71-4.38s3.69,1.85,3.69,4.37v.11c0,2.52-1.5,4.38-3.7,4.38S67.25,83.67,67.25,81.15Zm6.44,0v-.09c0-2.08-1.17-3.55-2.74-3.55S68.21,79,68.21,81v.09c0,2.08,1.17,3.55,2.75,3.55S73.69,83.22,73.69,81.14Z\" transform=\"translate(0.03 0)\"></path></g><g class=\"d\"><path class=\"b\" d=\"M76.38,76.79h2.95a3.1,3.1,0,0,1,2.25.8,2.47,2.47,0,0,1,.68,1.77v0a2.43,2.43,0,0,1-2,2.47l2.28,3.54H81.42L79.26,82H77.32v3.34h-.93Zm2.78,4.42c1.4,0,2.17-.7,2.17-1.79v0c0-1.13-.77-1.76-2.08-1.76H77.32v3.57Z\" transform=\"translate(0.03 0)\"></path></g><g class=\"d\"><path class=\"b\" d=\"M85.79,77.65H83.38v-.86h5.76v.86H86.72v7.74h-.92Z\" transform=\"translate(0.03 0)\"></path><path class=\"b\" d=\"M90.62,76.79h.93v3.84h4.14V76.79h.92v8.6h-.92V81.5H91.55v3.89h-.93Z\" transform=\"translate(0.03 0)\"></path><path class=\"b\" d=\"M98.34,81.15V81c0-2.52,1.52-4.38,3.71-4.38s3.68,1.85,3.68,4.37v.11c0,2.52-1.5,4.38-3.7,4.38S98.34,83.67,98.34,81.15Zm6.44,0v-.09c0-2.08-1.17-3.55-2.74-3.55S99.3,79,99.3,81v.09c0,2.08,1.17,3.55,2.75,3.55S104.78,83.22,104.78,81.14Z\" transform=\"translate(0.03 0)\"></path><path class=\"b\" d=\"M107.47,76.79h2.42a4,4,0,0,1,4,4.25v.09a4,4,0,0,1-4,4.26h-2.42Zm.93.85v6.9h1.47a3.08,3.08,0,0,0,3.11-3.4v-.09a3.09,3.09,0,0,0-3.11-3.42Z\" transform=\"translate(0.03 0)\"></path><path class=\"b\" d=\"M115.33,81.15V81c0-2.52,1.52-4.38,3.71-4.38s3.69,1.85,3.69,4.37v.11c0,2.52-1.5,4.38-3.7,4.38S115.33,83.67,115.33,81.15Zm6.44,0v-.09c0-2.08-1.17-3.55-2.74-3.55S116.29,79,116.29,81v.09c0,2.08,1.17,3.55,2.75,3.55S121.76,83.22,121.76,81.14Z\" transform=\"translate(0.03 0)\"></path><path class=\"b\" d=\"M124.45,76.79h.87l4.5,6.76V76.79h.91v8.6H130l-4.61-6.94v6.94h-.9Z\" transform=\"translate(0.03 0)\"></path><path class=\"b\" d=\"M134.63,77.65h-2.42v-.86H138v.86h-2.42v7.74h-.92Z\" transform=\"translate(0.03 0)\"></path><path class=\"b\" d=\"M139.53,76.79h.93v8.6h-.93Z\" transform=\"translate(0.03 0)\"></path><path class=\"b\" d=\"M142.27,81.14v-.09c0-2.59,1.62-4.38,3.77-4.38a3.62,3.62,0,0,1,2.63,1.07l-.58.71a2.9,2.9,0,0,0-2.09-.92c-1.57,0-2.78,1.45-2.78,3.53v0c0,2.11,1.22,3.55,2.79,3.55a2.86,2.86,0,0,0,2.13-1l.56.66A3.68,3.68,0,0,1,146,85.51C143.84,85.51,142.27,83.77,142.27,81.14Z\" transform=\"translate(0.03 0)\"></path><path class=\"b\" d=\"M149.58,84.3l.58-.7a3.44,3.44,0,0,0,2.42,1.07,1.55,1.55,0,0,0,1.73-1.44v0c0-.71-.36-1.17-1.92-1.72-1.78-.66-2.47-1.3-2.47-2.52v0a2.37,2.37,0,0,1,2.58-2.27,3.75,3.75,0,0,1,2.58,1l-.55.72a3,3,0,0,0-2.06-.85,1.45,1.45,0,0,0-1.62,1.34v0c0,.75.38,1.18,2,1.77s2.37,1.35,2.37,2.49v0a2.42,2.42,0,0,1-2.65,2.35A4.24,4.24,0,0,1,149.58,84.3Z\" transform=\"translate(0.03 0)\"></path></g></g></svg>"

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>phone</title><path d=\"M48.18,35.86c-2.64-2.1-5.41-4.16-8.1-6.21A4.89,4.89,0,0,0,36.24,29a5.5,5.5,0,0,0-2.36,1.81C32,33,30.21,33.54,28.55,33.39a8.06,8.06,0,0,1-4.74-2.59l-4.6-4.6a8.06,8.06,0,0,1-2.59-4.74c-.16-1.65.39-3.4,2.54-5.33A5.5,5.5,0,0,0,21,13.78a4.89,4.89,0,0,0-.62-3.84c-2-2.69-4.11-5.46-6.21-8.1A4.25,4.25,0,0,0,9.94.67,8,8,0,0,0,6.82,2.75C2.95,6.46-.36,11.54.67,17.77c.87,5,4.4,9.92,9.81,15.33l6.44,6.44c5.41,5.41,10.29,8.94,15.33,9.81,5.22.79,10.54-1.47,15-6.15a8,8,0,0,0,2.08-3.12A4.25,4.25,0,0,0,48.18,35.86Z\"></path></svg>"

/***/ }),
/* 520 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>quotessvg</title><path d=\"M12,9.18a12,12,0,0,0,0,24h.32c2.53-.15-6.07,12.52-5.84,12.34C21.43,39.7,24,25,24,21.2A12,12,0,0,0,12,9.18Z\"></path><path d=\"M38,9.18a12,12,0,1,0,0,24h.32c2.53-.15-6.07,12.52-5.84,12.34C47.4,39.7,50,25,50,21.2A12,12,0,0,0,38,9.18Z\"></path></svg>"

/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M24 0L29.8795 18.1266L48 18.3291L33.4458 29.7722L38.8434 48L24 36.962L9.15663 48L14.5542 29.7722L0 18.3291L18.2169 18.1266L24 0Z\"></path></svg>"

/***/ }),
/* 522 */,
/* 523 */,
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(504)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(586),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(503)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(577),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(597),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(599),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(585),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(611),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(596),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(606),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(576),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(591),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(607),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(580),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(603),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(574),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(578),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(565),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(589),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(590),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(601),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(598),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(595),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(605),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(568),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(584),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(600),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(604),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(593),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(573),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(575),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(609),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(566),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(583),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(602),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(610),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(571),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(587),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(608),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(569),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(579),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(572),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(582),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 565 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-treatment-itero"
  }, [_c('div', {
    staticClass: "custom-treatment-itero__container"
  }, [_c('div', {
    staticClass: "custom-treatment-itero__body"
  }, [_c('div', {
    staticClass: "custom-treatment-itero__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-treatment-itero__text",
    domProps: {
      "innerHTML": _vm._s(_vm.props.text)
    }
  })]), _c('div', {
    staticClass: "custom-treatment-itero__image",
    style: ({
      backgroundImage: 'url(' + _vm.props.image + ')'
    })
  })])])
},staticRenderFns: []}

/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("Oops! Can't find that page!")])
},staticRenderFns: []}

/***/ }),
/* 567 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-container",
    domProps: {
      "innerHTML": _vm._s(_vm.svg)
    }
  })
},staticRenderFns: []}

/***/ }),
/* 568 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-make-appointment"
  }, [_vm._m(0), _c('div', {
    staticClass: "form-make-appointment__container"
  }, [(_vm.formSubmitted) ? _c('div', {
    staticClass: "form-make-appointment__success-message"
  }, [_c('h2', [_vm._v("Thanks for submitting our form!")])]) : _vm._e(), (!_vm.formSubmitted) ? _c('form', {
    staticClass: "form-make-appointment__form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateBeforeSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-make-appointment__group"
  }, [_c('label', {
    staticClass: "form-make-appointment__label"
  }, [_vm._v("Patient Name*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.patient_name),
      expression: "patient_name"
    }],
    staticClass: "form-make-appointment__input",
    class: {
      'form-make-appointment__input--error': _vm.errors.has('patient-name')
    },
    attrs: {
      "name": "patient-name",
      "validate": 'required|alpha_spaces',
      "type": "text",
      "placeholder": "First & Last Name"
    },
    domProps: {
      "value": (_vm.patient_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.patient_name = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('patient-name')),
      expression: "errors.has('patient-name')"
    }],
    staticClass: "form-make-appointment__group__message"
  }, [_vm._v(_vm._s(_vm.errors.first('patient-name')))])]), _c('div', {
    staticClass: "form-make-appointment__group"
  }, [_c('label', {
    staticClass: "form-make-appointment__label"
  }, [_vm._v("New Patient?*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_patient),
      expression: "new_patient"
    }],
    staticClass: "form-make-appointment__checkbox",
    class: {
      'form-make-appointment__input--error': _vm.errors.has('new-patient')
    },
    attrs: {
      "name": "new-patient",
      "validate": 'required',
      "type": "radio",
      "value": "Yes"
    },
    domProps: {
      "checked": _vm._q(_vm.new_patient, "Yes")
    },
    on: {
      "change": function($event) {
        _vm.new_patient = "Yes"
      }
    }
  }), _c('span', {
    staticClass: "form-make-appointment__radio-label"
  }, [_vm._v("Yes")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_patient),
      expression: "new_patient"
    }],
    staticClass: "form-make-appointment__checkbox",
    class: {
      'form-make-appointment__input--error': _vm.errors.has('new-patient')
    },
    attrs: {
      "name": "new-patient",
      "validate": 'required',
      "type": "radio",
      "value": "No"
    },
    domProps: {
      "checked": _vm._q(_vm.new_patient, "No")
    },
    on: {
      "change": function($event) {
        _vm.new_patient = "No"
      }
    }
  }), _c('span', {
    staticClass: "form-make-appointment__radio-label"
  }, [_vm._v("No")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('new-patient')),
      expression: "errors.has('new-patient')"
    }],
    staticClass: "form-make-appointment__group__message"
  }, [_vm._v(_vm._s(_vm.errors.first('new-patient')))])]), _c('div', {
    staticClass: "form-make-appointment__group--option"
  }, [_c('div', {
    staticClass: "form-make-appointment__group"
  }, [_c('label', {
    staticClass: "form-make-appointment__label"
  }, [_vm._v("Email*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-make-appointment__input",
    class: {
      'input': true, 'form-make-appointment__input--error': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "placeholder": "Your Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('br'), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _c('div', {
    staticClass: "form-make-appointment__group"
  }, [_c('label', {
    staticClass: "form-make-appointment__label"
  }, [_vm._v("Phone")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    staticClass: "form-make-appointment__input",
    class: {
      'input': true, 'form-make-appointment__input--error': _vm.errors.has('email')
    },
    attrs: {
      "name": "phone",
      "placeholder": "Phone Number"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _c('br'), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('phone')),
      expression: "errors.has('phone')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('phone')))])])]), _c('div', {
    staticClass: "form-make-appointment__group form-make-appointment__group--option"
  }, [_c('label', {
    staticClass: "form-make-appointment__label"
  }, [_vm._v("Preferred Location*")]), _c('div', {
    staticClass: "form-make-appointment__groupouter"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-make-appointment__input--select",
    class: {
      'form-make-appointment__input--error': _vm.errors.has('name')
    },
    attrs: {
      "name": "selected"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "hidden": "hidden",
      "disabled": "disabled",
      "value": ""
    }
  }, [_vm._v("Preferred Location          ")]), _c('option', {
    attrs: {
      "value": "Eastern - 4306 S. Eastern Ave - 89119"
    }
  }, [_vm._v("Eastern (4306 S. Eastern Ave - 89119)")]), _c('option', {
    attrs: {
      "value": "Summerlin - 8551 W. Lake Mead Blvd - 89128"
    }
  }, [_vm._v("Summerlin (8551 W. Lake Mead Blvd - 89128)")])]), _c('BaseIcon', {
    staticClass: "form-make-appointment__arrow-icon",
    attrs: {
      "name": "arrow-down"
    }
  }), _c('div', {
    staticClass: "form-make-appointment__error"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('selected')),
      expression: "errors.has('selected')"
    }]
  }, [_vm._v("Please choose a location           ")])])], 1)]), _c('div', {
    staticClass: "form-make-appointment__group form-make-appointment__group--option"
  }, [_c('label', {
    staticClass: "form-make-appointment__label"
  }, [_vm._v("Preferred Days (select all that apply)")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appointment_monday),
      expression: "appointment_monday"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-make-appointment__checkbox",
    class: {
      'input': true, 'form-make-appointment__input--error': _vm.errors.has('appointment-times')
    },
    attrs: {
      "name": "appointment",
      "type": "checkbox",
      "value": "Monday"
    },
    domProps: {
      "checked": Array.isArray(_vm.appointment_monday) ? _vm._i(_vm.appointment_monday, "Monday") > -1 : (_vm.appointment_monday)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.appointment_monday,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Monday",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.appointment_monday = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.appointment_monday = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.appointment_monday = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "form-make-appointment__radio-label"
  }, [_vm._v("Mon ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appointment_tuesday),
      expression: "appointment_tuesday"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-make-appointment__checkbox",
    class: {
      'input': true, 'form-make-appointment__input--error': _vm.errors.has('appointment-times')
    },
    attrs: {
      "name": "phone",
      "type": "checkbox",
      "value": "Tuesday"
    },
    domProps: {
      "checked": Array.isArray(_vm.appointment_tuesday) ? _vm._i(_vm.appointment_tuesday, "Tuesday") > -1 : (_vm.appointment_tuesday)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.appointment_tuesday,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Tuesday",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.appointment_tuesday = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.appointment_tuesday = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.appointment_tuesday = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "form-make-appointment__radio-label"
  }, [_vm._v("Tues")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appointment_wednesday),
      expression: "appointment_wednesday"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-make-appointment__checkbox",
    class: {
      'input': true, 'form-make-appointment__input--error': _vm.errors.has('appointment-times')
    },
    attrs: {
      "name": "phone",
      "type": "checkbox",
      "value": "Wednesday"
    },
    domProps: {
      "checked": Array.isArray(_vm.appointment_wednesday) ? _vm._i(_vm.appointment_wednesday, "Wednesday") > -1 : (_vm.appointment_wednesday)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.appointment_wednesday,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Wednesday",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.appointment_wednesday = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.appointment_wednesday = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.appointment_wednesday = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "form-make-appointment__radio-label"
  }, [_vm._v("Wed")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appointment_thursday),
      expression: "appointment_thursday"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-make-appointment__checkbox",
    class: {
      'input': true, 'form-make-appointment__input--error': _vm.errors.has('appointment-times')
    },
    attrs: {
      "name": "phone",
      "type": "checkbox",
      "value": "Thursday"
    },
    domProps: {
      "checked": Array.isArray(_vm.appointment_thursday) ? _vm._i(_vm.appointment_thursday, "Thursday") > -1 : (_vm.appointment_thursday)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.appointment_thursday,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Thursday",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.appointment_thursday = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.appointment_thursday = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.appointment_thursday = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "form-make-appointment__radio-label"
  }, [_vm._v("Thurs")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appointment_friday),
      expression: "appointment_friday"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-make-appointment__checkbox",
    class: {
      'input': true, 'form-make-appointment__input--error': _vm.errors.has('appointment-times')
    },
    attrs: {
      "name": "phone",
      "type": "checkbox",
      "value": "Friday"
    },
    domProps: {
      "checked": Array.isArray(_vm.appointment_friday) ? _vm._i(_vm.appointment_friday, "Friday") > -1 : (_vm.appointment_friday)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.appointment_friday,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Friday",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.appointment_friday = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.appointment_friday = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.appointment_friday = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "form-make-appointment__radio-label"
  }, [_vm._v("Fri")])]), _c('div', {
    staticClass: "form-make-appointment__group form-make-appointment__group--option"
  }, [_c('label', {
    staticClass: "form-make-appointment__label"
  }, [_vm._v("Preferred Times (select all that apply)")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appointment_8am),
      expression: "appointment_8am"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-make-appointment__checkbox",
    class: {
      'input': true, 'form-make-appointment__input--error': _vm.errors.has('appointment-times')
    },
    attrs: {
      "name": "appointment-times",
      "type": "checkbox",
      "value": "8am-11am"
    },
    domProps: {
      "checked": Array.isArray(_vm.appointment_8am) ? _vm._i(_vm.appointment_8am, "8am-11am") > -1 : (_vm.appointment_8am)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.appointment_8am,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "8am-11am",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.appointment_8am = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.appointment_8am = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.appointment_8am = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "form-make-appointment__radio-label"
  }, [_vm._v("8am-11am   ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appointment_11am),
      expression: "appointment_11am"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-make-appointment__checkbox",
    class: {
      'input': true, 'form-make-appointment__input--error': _vm.errors.has('appointment-times')
    },
    attrs: {
      "name": "appointment-times",
      "type": "checkbox",
      "value": "11am-2pm"
    },
    domProps: {
      "checked": Array.isArray(_vm.appointment_11am) ? _vm._i(_vm.appointment_11am, "11am-2pm") > -1 : (_vm.appointment_11am)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.appointment_11am,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "11am-2pm",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.appointment_11am = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.appointment_11am = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.appointment_11am = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "form-make-appointment__radio-label"
  }, [_vm._v("11am-2pm")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appointment_2pm),
      expression: "appointment_2pm"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-make-appointment__checkbox",
    class: {
      'input': true, 'form-make-appointment__input--error': _vm.errors.has('appointment-times')
    },
    attrs: {
      "name": "appointment-times",
      "type": "checkbox",
      "value": "2pm-5pm"
    },
    domProps: {
      "checked": Array.isArray(_vm.appointment_2pm) ? _vm._i(_vm.appointment_2pm, "2pm-5pm") > -1 : (_vm.appointment_2pm)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.appointment_2pm,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "2pm-5pm",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.appointment_2pm = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.appointment_2pm = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.appointment_2pm = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "form-make-appointment__radio-label"
  }, [_vm._v("2pm-5pm")])]), _c('div', {
    staticClass: "form-make-appointment__group form-make-appointment__group--option"
  }, [_c('label', {
    staticClass: "form-make-appointment__label"
  }, [_vm._v("How did you hear about our practice?")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hear),
      expression: "hear"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-make-appointment__input form-make-appointment__input--option",
    class: {
      'input': true, 'form-make-appointment__input--error': _vm.errors.has('hear')
    },
    attrs: {
      "name": "hear",
      "placeholder": "Select an option"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "none"
    }
  }, [_vm._v("Select an Option")]), _c('option', {
    attrs: {
      "value": "Friend"
    }
  }, [_vm._v("Friend")]), _c('option', {
    attrs: {
      "value": "Spouse"
    }
  }, [_vm._v("Spouse")]), _c('option', {
    attrs: {
      "value": "Online Ad"
    }
  }, [_vm._v("Online Ad")]), _c('option', {
    attrs: {
      "value": "Google Search"
    }
  }, [_vm._v("Google Search")]), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v("Other")])])]), _c('div', {
    staticClass: "form-make-appointment__group form-make-appointment__group--option"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-make-appointment__input form-make-appointment__input--option",
    class: {
      'input': true, 'form-make-appointment__input--error': _vm.errors.has('message')
    },
    attrs: {
      "name": "message",
      "placeholder": "Message",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })]), _vm._m(1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-make-appointment__container"
  }, [_c('div', {
    staticClass: "form-make-appointment__title"
  }, [_vm._v("Make an Appointment")]), _c('div', {
    staticClass: "form-make-appointment__content"
  }, [_vm._v("We offer a complimentary initial consultation to determine if orthodontic tratment is right for you.  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-make-appointment__group form-make-appointment__group--center"
  }, [_c('input', {
    staticClass: "form-make-appointment__submit-button",
    attrs: {
      "type": "submit",
      "value": "Send"
    }
  })])
}]}

/***/ }),
/* 569 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "pages-reviews"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), (!_vm.loading && _vm.props) ? _c('div', [_c('div', {
    staticClass: "pages-reviews__header",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.reviews_banner + ')'
    })
  }), _c('BlockTitle', {
    attrs: {
      "props": _vm.props.acf.block_title
    }
  }), _c('CustomReviewsContent', {
    attrs: {
      "props": _vm.props.acf.reviews_links
    }
  }), _c('div', {
    staticClass: "pages-reviews__wrap"
  }, [_c('div', {
    staticClass: "pages-reviews__container"
  }, [_c('div', {
    staticClass: "pages-reviews__slider"
  }, [_c('Carousel', {
    attrs: {
      "navigationEnabled": true,
      "autoplay": false,
      "perPage": 3,
      "loop": true,
      "navigationNextLabel": _vm.arrowNext,
      "navigationPrevLabel": _vm.arrowPrev,
      "paginationActiveColor": "#30a4cd",
      "paginationColor": "#000",
      "paginationSize": 12,
      "perPageCustom": [
        [350, 1],
        [650, 2],
        [1024, 3]
      ]
    }
  }, _vm._l((_vm.props.acf.reviews_list), function(slide, i) {
    return _c('Slide', {
      key: i
    }, [_c('div', {
      staticClass: "pages-reviews__slide"
    }, [_c('span', {
      staticClass: "pages-reviews__ratingwrap"
    }, [_c('Icon', {
      staticClass: "pages-reviews__googleicon",
      attrs: {
        "name": "google-circle"
      }
    }), _c('span', {
      staticClass: "pages-reviews__rating"
    }, [_vm._v("5.0 ")]), _vm._l((5), function(n) {
      return _c('Icon', {
        key: n,
        staticClass: "pages-reviews__star",
        attrs: {
          "name": "star"
        }
      })
    })], 2), _c('div', {
      staticClass: "pages-reviews__author",
      domProps: {
        "innerHTML": _vm._s(slide.author)
      }
    }), _c('div', {
      staticClass: "pages-reviews__text",
      domProps: {
        "innerHTML": _vm._s(slide.description)
      }
    })])])
  }))], 1)])])], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 570 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "divider-text"
  }, [_c('div', {
    staticClass: "divider-text__clip"
  }, [_c('parallax', {
    attrs: {
      "speedFactor": .2,
      "direction": "up",
      "sectionHeight": 200
    }
  }, [_c('div', {
    staticClass: "divider-text__bg",
    style: ({
      backgroundImage: 'url(' + _vm.props.image + ')'
    })
  })])], 1), _c('div', {
    staticClass: "divider-text__body"
  }, [_c('div', {
    staticClass: "divider-text__container"
  }, [_c('div', {
    staticClass: "divider-text__text",
    style: ({
      float: _vm.props.location
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.props.text)
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 571 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-contact-us"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('BlockTitle', {
    attrs: {
      "props": _vm.props.acf.block_title
    }
  }), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "padding-left": "1rem",
      "padding-right": "1rem"
    }
  }, [_vm._v("Note: Each location has designated hours & days open for in-person patient care that vary weekly.")]), _c('FormContact', {
    attrs: {
      "props": _vm.props.acf
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 572 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-welchorthodontics"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), (!_vm.loading && _vm.props) ? _c('div', [_c('CustomWelchConsultation', {
    attrs: {
      "props": _vm.props.acf.custom_welch_consultation
    }
  }), _c('CustomWelchSections', {
    attrs: {
      "props": _vm.props.acf.custom_welch_sections
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 573 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider-about-us-doctors"
  }, [_c('div', {
    staticClass: "slider-about-us-doctors__container"
  }, [_c('div', {
    staticClass: "slider-about-us-doctors__slider"
  }, [_c('Carousel', {
    attrs: {
      "navigationEnabled": true,
      "autoplay": false,
      "perPage": 2,
      "loop": true,
      "navigationNextLabel": _vm.arrowNext,
      "navigationPrevLabel": _vm.arrowPrev,
      "paginationActiveColor": "#30a4cd",
      "paginationColor": "#fff",
      "paginationSize": 15
    }
  }, _vm._l((_vm.props.gallery), function(slide, i) {
    return _c('Slide', {
      key: i
    }, [_c('div', {
      staticClass: "slider-about-us-doctors__slide",
      style: ({
        backgroundImage: 'url(' + slide.url + ')'
      })
    })])
  }))], 1), _c('div', {
    staticClass: "slider-about-us-doctors__slider--mobile"
  }, [_c('Carousel', {
    attrs: {
      "navigationEnabled": true,
      "autoplay": false,
      "perPage": 1,
      "loop": true,
      "navigationNextLabel": _vm.arrowNext,
      "navigationPrevLabel": _vm.arrowPrev,
      "paginationActiveColor": "#30a4cd",
      "paginationColor": "#fff",
      "paginationSize": 10
    }
  }, _vm._l((_vm.props.gallery), function(slide, i) {
    return _c('Slide', {
      key: i
    }, [_c('div', {
      staticClass: "slider-about-us-doctors__slide",
      style: ({
        backgroundImage: 'url(' + slide.url + ')'
      })
    })])
  }))], 1)])])
},staticRenderFns: []}

/***/ }),
/* 574 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-treatment-accelerated-treatments"
  }, [_c('div', {
    staticClass: "custom-treatment-accelerated-treatments__container"
  }, [_c('div', {
    staticClass: "custom-treatment-accelerated-treatments__image",
    style: ({
      backgroundImage: 'url(' + _vm.props.image + ')'
    })
  }), _c('div', {
    staticClass: "custom-treatment-accelerated-treatments__body"
  }, [_c('div', {
    staticClass: "custom-treatment-accelerated-treatments__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-treatment-accelerated-treatments__text",
    domProps: {
      "innerHTML": _vm._s(_vm.props.text)
    }
  })])]), _c('div', {
    staticClass: "custom-treatment-accelerated-treatments__container"
  }, _vm._l((_vm.props.tabs), function(tab) {
    return _c('div', {
      staticClass: "custom-treatment-accelerated-treatments__tabs"
    }, [_c('div', {
      staticClass: "custom-treatment-accelerated-treatments__tab"
    }, [_c('div', {
      staticClass: "custom-treatment-accelerated-treatments__tab-image",
      style: ({
        backgroundImage: 'url(' + tab.image + ')'
      })
    }), _c('div', {
      staticClass: "custom-treatment-accelerated-treatments__tab-title",
      domProps: {
        "innerHTML": _vm._s(tab.title)
      }
    }), _c('div', {
      staticClass: "custom-treatment-accelerated-treatments__tab-text",
      domProps: {
        "innerHTML": _vm._s(tab.text)
      }
    })])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 575 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider-about-us-team"
  }, [_c('div', {
    staticClass: "slider-about-us-team__container"
  }, [_c('div', {
    staticClass: "slider-about-us-team__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "slider-about-us-team__slider"
  }, [_c('Carousel', {
    attrs: {
      "navigationEnabled": true,
      "autoplay": false,
      "perPage": 2,
      "loop": true,
      "navigationNextLabel": _vm.arrowNext,
      "navigationPrevLabel": _vm.arrowPrev,
      "paginationActiveColor": "#30a4cd",
      "paginationColor": "#fff",
      "paginationSize": 15
    }
  }, _vm._l((_vm.props.gallery), function(slide, j) {
    return _c('Slide', {
      key: j
    }, [_c('div', {
      staticClass: "slider-about-us-team__slide",
      style: ({
        backgroundImage: 'url(' + slide.url + ')'
      })
    })])
  }))], 1), _c('div', {
    staticClass: "slider-about-us-team__slider--mobile"
  }, [_c('Carousel', {
    attrs: {
      "navigationEnabled": true,
      "autoplay": false,
      "perPage": 1,
      "loop": true,
      "navigationNextLabel": _vm.arrowNext,
      "navigationPrevLabel": _vm.arrowPrev,
      "paginationActiveColor": "#30a4cd",
      "paginationColor": "#fff",
      "paginationSize": 10
    }
  }, _vm._l((_vm.props.gallery), function(slide, j) {
    return _c('Slide', {
      key: j
    }, [_c('div', {
      staticClass: "slider-about-us-team__slide",
      style: ({
        backgroundImage: 'url(' + slide.url + ')'
      })
    })])
  }))], 1)])])
},staticRenderFns: []}

/***/ }),
/* 576 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-home-tabs"
  }, [_c('div', {
    staticClass: "custom-home-tabs__container"
  }, [_c('div', {
    staticClass: "custom-home-tabs__tabs"
  }, _vm._l((_vm.props.tabs), function(tab) {
    return _c('div', {
      staticClass: "custom-home-tabs__tab"
    }, [_c('div', {
      staticClass: "custom-home-tabs__icon"
    }, [_c('object', {
      attrs: {
        "aria-label": "What sets us apart",
        "type": "image/svg+xml",
        "data": tab.icon
      }
    })]), _c('div', {
      staticClass: "custom-home-tabs__title",
      domProps: {
        "innerHTML": _vm._s(tab.title)
      }
    }), _c('div', {
      staticClass: "custom-home-tabs__content",
      domProps: {
        "innerHTML": _vm._s(tab.text)
      }
    })])
  }))]), _c('div', {
    staticClass: "custom-home-tabs__container"
  }, [_c('router-link', {
    attrs: {
      "to": "/treatment#accelerated"
    }
  }, [_c('div', {
    staticClass: "custom-home-tabs__cta",
    domProps: {
      "innerHTML": _vm._s(_vm.props.cta)
    }
  })])], 1)])
},staticRenderFns: []}

/***/ }),
/* 577 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.path !== '/accessibility') ? _c('div', {
    staticClass: "base-access"
  }, [_c('div', {
    staticClass: "base-access__container"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s((_vm.companyName + " Accessibility Statement"))
    }
  }), _c('p', {
    domProps: {
      "innerHTML": _vm._s((_vm.companyName + " is committed to facilitating the accessibility and usability of its website, " + _vm.domain + ", for everyone. " + _vm.companyName + " aims to comply with all applicable standards, including the World Wide Web Consortiums Web Content Accessibility Guidelines 2.0 up to Level AA (WCAG 2.0 AA). " + _vm.companyName + " is proud of the efforts that we have completed and that are in-progress to ensure that our website is accessible to everyone."))
    }
  }), _c('p', {
    domProps: {
      "innerHTML": _vm._s(("We highly recommend using the userway accessibility widget linked in the footer, but should you experience any difficulty in accessing any part of this website, please feel free to " + (_vm.phone ? "call us at " + _vm.phone : "") + " " + (_vm.phone && _vm.email ? "or" : "") + " " + (_vm.email ? "email us at " + _vm.email : "") + " and we will work with you to provide the information or service you seek through an alternate communication method that is accessible for you consistent with applicable law (for example, through telephone support)."))
    }
  })])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 578 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-treatment-invisalign"
  }, [_c('div', {
    staticClass: "custom-treatment-invisalign__container"
  }, [_c('div', {
    staticClass: "custom-treatment-invisalign__text"
  }, [_c('div', {
    staticClass: "custom-treatment-invisalign__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-treatment-invisalign__body",
    domProps: {
      "innerHTML": _vm._s(_vm.props.body)
    }
  })]), _c('div', {
    staticClass: "custom-treatment-invisalign__image",
    style: ({
      backgroundImage: 'url(' + _vm.props.image + ')'
    })
  }), _c('img', {
    staticClass: "custom-treatment-invisalign__logo",
    attrs: {
      "src": _vm.props.logo
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 579 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-treatment"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('BlockTitle', {
    attrs: {
      "props": _vm.props.acf.block_title
    }
  }), _c('CustomTreatmentInvisalign', {
    attrs: {
      "props": _vm.props.acf.custom_treatment_invisalign
    }
  }), _c('CustomTreatmentTabs', {
    attrs: {
      "props": _vm.props.acf.custom_treatment_tabs
    }
  }), _c('DividerText', {
    attrs: {
      "props": _vm.props.acf.divider_text
    }
  }), _c('CustomTreatmentAcceleratedTreatments', {
    attrs: {
      "props": _vm.props.acf.custom_treatment_accelerated_treatments,
      "id": "accelerated"
    }
  }), _c('CustomTreatmentItero', {
    attrs: {
      "props": _vm.props.acf.custom_treatment_itero
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 580 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-new-patients-tabs"
  }, [_c('div', {
    staticClass: "custom-new-patients-tabs__container"
  }, [_c('div', {
    staticClass: "custom-new-patients-tabs__tabs"
  }, _vm._l((_vm.props.tabs), function(tab, i) {
    return _c('div', {
      staticClass: "custom-new-patients-tabs__tab"
    }, [_c('div', {
      staticClass: "custom-new-patients-tabs__body"
    }, [_c('div', {
      staticClass: "custom-new-patients-tabs__icon"
    }, [_c('object', {
      attrs: {
        "type": "image/svg+xml",
        "data": tab.icon
      }
    })]), _c('div', {
      staticClass: "custom-new-patients-tabs__title",
      domProps: {
        "innerHTML": _vm._s(tab.title)
      }
    }), _c('div', {
      staticClass: "custom-new-patients-tabs__text",
      domProps: {
        "innerHTML": _vm._s(tab.text)
      }
    })]), (i === 0 || i === 1) ? _c('div', {
      staticClass: "custom-new-patients-tabs__arrow"
    }, [_c('Icon', {
      attrs: {
        "name": "arrow"
      }
    })], 1) : _vm._e()])
  }))])])
},staticRenderFns: []}

/***/ }),
/* 581 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-title"
  }, [(_vm.props) ? _c('div', {
    staticClass: "block-title__container"
  }, [_c('div', {
    staticClass: "block-title__bg"
  }, [(_vm.props.background_text) ? _c('object', {
    attrs: {
      "type": "image/svg+xml",
      "data": _vm.props.background_text
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "block-title__text",
    domProps: {
      "innerHTML": _vm._s(_vm.props.main_text)
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dev) ? _c('div', {
    staticClass: "revisions",
    class: {
      'revisions--active': _vm.active
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.active),
      expression: "!active"
    }],
    staticClass: "revisions__button",
    on: {
      "click": function($event) {
        _vm.active = true
      }
    }
  }, [_c('span'), _c('span')]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active),
      expression: "active"
    }],
    staticClass: "revisions__form"
  }, [_c('div', {
    staticClass: "revisions__close",
    on: {
      "click": function($event) {
        _vm.active = false
      }
    }
  }, [_vm._v("CLOSE")]), _c('iframe', {
    attrs: {
      "src": "https://docs.google.com/forms/d/e/1FAIpQLSfLeHvnaFJ_xDcoO3DPuW3dpkp4PRzgxr06Jh6kskLqchrOGQ/viewform?embedded=true",
      "frameborder": "0",
      "marginheight": "0",
      "marginwidth": "0"
    }
  }, [_vm._v("Loading...")])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 583 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-about-us"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), (!_vm.loading && _vm.props) ? _c('div', [_c('BlockTitle', {
    attrs: {
      "props": _vm.props.acf.block_title
    }
  }), _c('CustomAboutUsSections', {
    attrs: {
      "props": _vm.props.acf.custom_about_us_sections
    }
  }), _c('SliderAboutUsDoctors', {
    attrs: {
      "props": _vm.props.acf.slider_about_us_doctors
    }
  }), _c('SliderAboutUsTeam', {
    attrs: {
      "props": _vm.props.acf.slider_about_us_team
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 584 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero__bg",
    style: ({
      backgroundImage: 'url(' + _vm.props.image + ')'
    })
  }, [_c('img', {
    staticClass: "hero__invisalign-logo",
    attrs: {
      "alt": "invisalign",
      "src": _vm.props.logo
    }
  }), _c('div', {
    ref: "text",
    staticClass: "hero__text",
    domProps: {
      "innerHTML": _vm._s(_vm.props.text)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-paragraph"
  }, [_c('div', {
    staticClass: "block-paragraph__container"
  }, [_c('div', {
    staticClass: "block-paragraph__body",
    domProps: {
      "innerHTML": _vm._s(_vm.props.text)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('BaseBaseAccess'), _c('Navigation'), _c('router-view'), _c('FooterMain'), _c('Revisions')], 1)
},staticRenderFns: []}

/***/ }),
/* 587 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-home"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('Hero', {
    attrs: {
      "props": _vm.props.acf.hero
    }
  }), _c('v-waypoint', {
    on: {
      "waypoint": _vm.change
    }
  }), _c('BlockIntro', {
    attrs: {
      "props": _vm.props.acf.block_intro
    }
  }), _c('BlockCtaModal', {
    attrs: {
      "props": _vm.props.acf.block_cta_modal
    }
  }), _c('DividerText', {
    attrs: {
      "props": _vm.props.acf.divider_text
    }
  }), _c('CustomHomeTabs', {
    attrs: {
      "props": _vm.props.acf.custom_home_tabs
    }
  }), _c('SliderTestimonials', {
    attrs: {
      "props": _vm.props.acf.slider_testimonials
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-overlay"
  }, [_c('div', {
    staticClass: "loader"
  })])
}]}

/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-treatment-tabs"
  }, [_c('div', {
    staticClass: "custom-treatment-tabs__container"
  }, [_c('div', {
    staticClass: "custom-treatment-tabs__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-treatment-tabs__body"
  }, [_c('div', {
    staticClass: "custom-treatment-tabs__tabs"
  }, [_vm._l((_vm.props.tabs), function(tab, i) {
    return _c('div', {
      staticClass: "custom-treatment-tabs__tab",
      class: {
        'custom-treatment-tabs__tab--active': i === _vm.active
      },
      domProps: {
        "innerHTML": _vm._s(tab.title)
      },
      on: {
        "click": function($event) {
          _vm.active = i
        }
      }
    })
  }), _vm._l((_vm.props.tabs), function(content, j) {
    return (j === _vm.active) ? _c('div', {
      staticClass: "custom-treatment-tabs__content",
      class: {
        'custom-treatment-tabs__content--active': j === _vm.active
      }
    }, [_c('div', {
      staticClass: "custom-treatment-tabs__image",
      style: ({
        backgroundImage: 'url(' + content.image + ')'
      })
    }), _c('div', {
      staticClass: "custom-treatment-tabs__text",
      domProps: {
        "innerHTML": _vm._s(content.content)
      }
    })]) : _vm._e()
  })], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 590 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-welch-consultation"
  }, [_c('div', {
    staticClass: "custom-welch-consultation__container"
  }, [_c('div', {
    staticClass: "custom-welch-consultation__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-welch-consultation__content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.text)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 591 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-new-patients-consultation"
  }, [_c('div', {
    staticClass: "custom-new-patients-consultation__container"
  }, [_c('div', {
    staticClass: "custom-new-patients-consultation__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-new-patients-consultation__content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.text)
    }
  }), _c('div', {
    staticClass: "openchair-widget custom-new-patients-consultation__button",
    domProps: {
      "innerHTML": _vm._s(_vm.props.button)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.showModal) ? _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal__bg"
  }, [_c('div', {
    staticClass: "modal__body"
  }, [_c('div', {
    staticClass: "modal__close",
    on: {
      "click": _vm.close
    }
  }, [_c('Icon', {
    attrs: {
      "name": "close"
    }
  })], 1), _c('div', {
    staticClass: "modal__form"
  }, [_c('Form')], 1)])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navigation"
  }, [_c('Desktop', {
    attrs: {
      "props": _vm.props
    }
  }), _c('Mobile', {
    attrs: {
      "props": _vm.props
    }
  }), _vm._m(0), _c('Modal')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navigation__translate"
  }, [_c('div', {
    attrs: {
      "id": "google_translate_element"
    }
  })])
}]}

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-contact"
  }, [_c('div', {
    staticClass: "modal-contact__container"
  }, [_c('div', {
    staticClass: "modal-contact__button",
    on: {
      "click": _vm.open
    }
  }, [_vm._v("Button")])]), (_vm.$store.state.showModal) ? _c('div', {
    staticClass: "modal-contact__body"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.  ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer-main"
  }, [(_vm.props.app) ? _c('div', {
    staticClass: "footer-main__bg"
  }, [_c('div', {
    staticClass: "footer-main__container"
  }, [_c('div', {
    staticClass: "footer-main__contact"
  }, [_c('h4', [_vm._v("Two Convenient Locations:")]), _c('div', {
    staticClass: "notranslate footer-main__contact--section",
    domProps: {
      "innerHTML": _vm._s(_vm.props.app.acf.information.address)
    }
  }), _c('a', {
    staticClass: "footer-main__contact--section",
    attrs: {
      "href": "tel:+17027354169"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.app.acf.information.phone_display)
    }
  }), _c('hr'), _c('div', {
    staticClass: "notranslate footer-main__contact--section",
    domProps: {
      "innerHTML": _vm._s(_vm.props.app.acf.information.address_copy)
    }
  }), _c('a', {
    staticClass: "footer-main__contact--section",
    attrs: {
      "href": "tel:+17022402300"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.app.acf.information.phone_display_copy)
    }
  }), _c('div', {
    staticClass: "footer-main__social-links"
  }, _vm._l((_vm.props.app.acf.information.social_links), function(social) {
    return _c('a', {
      staticClass: "footer-main__social-link",
      attrs: {
        "aria-label": "Social Link",
        "href": social.link,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "footer-main__social-icon",
      attrs: {
        "alt": "lvosmiles social",
        "src": social.icon
      }
    })])
  }))]), _c('div', {
    staticClass: "footer-main__logo"
  }, [_c('Icon', {
    attrs: {
      "name": "logo-footer"
    }
  })], 1), _c('div', {
    staticClass: "footer-main__trademarks"
  }, [_c('div', {
    staticClass: "footer-main__right"
  }, [_c('a', {
    staticClass: "footer-main__contact--section",
    attrs: {
      "target": "_blank",
      "href": _vm.props.app.acf.information.doc_link
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.app.acf.information.doc_display)
    }
  }), _c('a', {
    staticClass: "footer-main__contact--section",
    attrs: {
      "target": "_blank",
      "href": _vm.props.app.acf.information.certificate_url
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.app.acf.information.cerificate_text)
    }
  }), _c('a', {
    staticClass: "footer-main__contact--section",
    attrs: {
      "target": "_blank",
      "href": _vm.props.app.acf.information.reward_url
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.app.acf.information.reward_text)
    }
  }), _c('a', {
    staticClass: "footer-main__contact--section",
    attrs: {
      "target": "_blank",
      "href": _vm.props.app.acf.information.image_request_link
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.app.acf.information.image_request_display)
    }
  }), (_vm.props.app.acf.information.phone_hours) ? _c('div', {
    staticClass: "footer-main__phone",
    domProps: {
      "innerHTML": _vm._s(_vm.props.app.acf.information.phone_hours)
    }
  }) : _vm._e(), (_vm.props.app.acf.information.working_hours) ? _c('div', {
    staticClass: "footer-main__hours",
    domProps: {
      "innerHTML": _vm._s(_vm.props.app.acf.information.working_hours)
    }
  }) : _vm._e(), _c('br'), _c('div', {
    staticClass: "footer-main__roostergrin",
    domProps: {
      "innerHTML": _vm._s(_vm.props.app.acf.information.trademark)
    }
  })])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "fade",
    staticClass: "custom-about-us-sections"
  }, _vm._l((_vm.props.sections), function(section, i) {
    return _c('div', {
      staticClass: "custom-about-us-sections__section"
    }, [_c('div', {
      staticClass: "custom-about-us-sections__container"
    }, [_c('div', {
      staticClass: "custom-about-us-sections__body",
      class: {
        'custom-about-us-sections__body--float': i % 2 !== 0
      }
    }, [_c('div', {
      staticClass: "custom-about-us-sections__title",
      domProps: {
        "innerHTML": _vm._s(section.title)
      }
    }), _c('div', {
      staticClass: "custom-about-us-sections__content",
      domProps: {
        "innerHTML": _vm._s(section.content)
      }
    })]), _c('div', {
      ref: "slide",
      refInFor: true,
      staticClass: "custom-about-us-sections__image",
      class: {
        'custom-about-us-sections__image--float': i % 2 !== 0
      },
      style: ({
        backgroundImage: 'url(' + section.image + ')'
      })
    })])])
  }))
},staticRenderFns: []}

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-cta-modal"
  }, [_c('div', {
    staticClass: "block-cta-modal__bg"
  }, [_c('div', {
    staticClass: "block-cta-modal__container"
  }, [_c('div', {
    staticClass: "block-cta-modal__body"
  }, [_c('div', {
    staticClass: "block-cta-modal__text",
    domProps: {
      "innerHTML": _vm._s(_vm.props.text)
    }
  }), (_vm.props.add_openchair) ? _c('div', {
    staticClass: "block-cta-modal__button",
    class: 'openchair-widget',
    attrs: {
      "tabindex": "0",
      "aria-label": _vm.props.aria ? _vm.props.aria : null
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.button)
    },
    on: {
      "click": _vm.onClick
    }
  }) : (!_vm.alt) ? _c('div', {
    staticClass: "block-cta-modal__button",
    domProps: {
      "innerHTML": _vm._s(_vm.props.button)
    },
    on: {
      "click": _vm.activate
    }
  }) : (_vm.alt) ? _c('div', {
    staticClass: "block-cta-modal__button",
    domProps: {
      "innerHTML": _vm._s(_vm.props.button)
    },
    on: {
      "click": _vm.toggleModal
    }
  }) : _vm._e()])])])])
},staticRenderFns: []}

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "divider-logos"
  }, [_c('div', {
    staticClass: "divider-logos__container"
  }, _vm._l((_vm.props.logos), function(logo) {
    return _c('div', {
      staticClass: "divider-logos__logo"
    }, [_c('img', {
      attrs: {
        "src": logo.url
      }
    })])
  }))])
},staticRenderFns: []}

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-intro"
  }, [_c('div', {
    staticClass: "block-intro__bg"
  }, [_c('object', {
    attrs: {
      "aria-label": "Love To Smile",
      "type": "image/svg+xml",
      "data": _vm.props.background
    }
  })]), _c('div', {
    staticClass: "block-intro__container"
  }, [_c('div', {
    staticClass: "block-intro__body"
  }, [_c('div', {
    staticClass: "block-intro__text",
    domProps: {
      "innerHTML": _vm._s(_vm.props.text)
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navigation-desktop",
    class: {
      'navigation-desktop--active': _vm.$store.state.nav
    }
  }, [_c('div', {
    staticClass: "navigation-desktop__container"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('div', {
    staticClass: "navigation-desktop__logo",
    class: {
      'navigation-desktop__logo--active': _vm.$store.state.nav
    }
  }, [_c('Icon', {
    attrs: {
      "name": "logo"
    }
  })], 1)]), _c('div', {
    staticClass: "navigation-desktop__links"
  }, [_vm._l((_vm.props), function(nav) {
    return (nav.navigation) ? _c('div', {
      staticClass: "navigation-desktop__link"
    }, [_c('router-link', {
      attrs: {
        "to": nav.path
      }
    }, [_c('a', [_vm._v(_vm._s(nav.name))])])], 1) : _vm._e()
  }), _c('div', {
    staticClass: "navigation-desktop__link-box"
  }, [_c('div', {
    staticClass: "navigation-desktop__link navigation-desktop__link--option openchair-widget"
  }, [_c('Icon', {
    attrs: {
      "name": "calendar"
    }
  }), _vm._v("Appointment Link")], 1), _c('br'), _c('div', {
    staticClass: "navigation-desktop__link navigation-desktop__link--option customphonebtn"
  }, [_c('div', {
    staticClass: "navigation-desktop__custombtnlink",
    attrs: {
      "id": "custombntlink",
      "onclick": "openLocation()"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "phone"
    }
  }), _c('span', {
    staticClass: "btntext"
  }, [_vm._v("Call Us")])], 1), _vm._m(0)])])], 2)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navigation-desktop__location_list",
    attrs: {
      "id": "custombntlinkopen"
    }
  }, [_c('a', {
    attrs: {
      "href": "tel:+17027354169"
    }
  }, [_vm._v("Eastern")]), _c('a', {
    attrs: {
      "href": "tel:+17023645100"
    }
  }, [_vm._v("Summerlin")])])
}]}

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "fade",
    staticClass: "custom-welch-sections"
  }, [_vm._l((_vm.props.sections), function(section, i) {
    return _c('div', {
      staticClass: "custom-welch-sections__section"
    }, [_c('div', {
      staticClass: "custom-welch-sections__container"
    }, [_c('div', {
      staticClass: "custom-welch-sections__body",
      class: {
        'custom-welch-sections__body--float': i % 2 !== 0
      }
    }, [_c('div', {
      staticClass: "custom-welch-sections__title",
      domProps: {
        "innerHTML": _vm._s(section.title)
      }
    }), _c('div', {
      staticClass: "custom-welch-sections__content",
      domProps: {
        "innerHTML": _vm._s(section.content)
      }
    })]), _c('div', {
      ref: "slide",
      refInFor: true,
      staticClass: "custom-welch-sections__image",
      class: {
        'custom-welch-sections__image--float': i % 2 !== 0
      },
      style: ({
        backgroundImage: 'url(' + section.image + ')'
      })
    })])])
  }), _c('div', {
    staticClass: "custom-welch-sections__signoff"
  }, [_c('div', {
    staticClass: "custom-welch-sections__container"
  }, [_c('div', {
    staticClass: "custom-welch-sections__signoff-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.sign_off_content)
    }
  })])])], 2)
},staticRenderFns: []}

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-about-us"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), (!_vm.loading && _vm.props) ? _c('div', {
    staticClass: "accesswrap"
  }, [_c('div', {
    staticClass: "custom-about-us-sections__section"
  }, [_c('div', {
    staticClass: "custom-about-us-sections__container"
  }, [_c('div', {
    staticClass: "custom-about-us-sections__title",
    domProps: {
      "innerHTML": _vm._s((_vm.companyName + " Accessibility Statement"))
    }
  }), _c('div', {
    staticClass: "custom-about-us-sections__content"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s((_vm.companyName + " is committed to facilitating the accessibility and usability of its website, " + _vm.domain + ", for everyone.  " + _vm.companyName + " aims to comply with all applicable standards, including the World Wide Web Consortiums Web Content Accessibility Guidelines 2.0 up to Level AA (WCAG 2.0 AA). " + _vm.companyName + " is proud of the efforts that we have completed and that are in-progress to ensure that our website is accessible to everyone."))
    }
  }), _c('p', {
    domProps: {
      "innerHTML": _vm._s(("We highly recommend using the userway accessibility widget linked in the footer, but should you experience any difficulty in accessing any part of this website, please feel free to " + (_vm.phone ? "call us at " + _vm.phone : "") + " " + (_vm.phone && _vm.email ? "or" : "") + " " + (_vm.email ? "email us at " + _vm.formattedEmail : "") + " and we will work with you to provide the information or service you seek through an alternate communication method that is accessible for you consistent with applicable law (for example, through telephone support)."))
    }
  })])])])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-reviews-content"
  }, [_c('div', {
    staticClass: "custom-reviews-content__container"
  }, [(_vm.location == "unknown") ? _c('div', {
    staticClass: "custom-reviews-content__location"
  }, [_c('h2', {
    staticClass: "custom-reviews-content__location-header"
  }, [_vm._v("Let Us Know What You Think!")]), _c('br'), _c('div', {
    staticClass: "custom-reviews-content__location-title"
  }, [_vm._v("Choose Your Location")]), _c('a', {
    staticClass: "custom-reviews-content__location-button",
    style: ({
      'background': '#3FD5AF'
    }),
    on: {
      "click": function($event) {
        _vm.isLocation("las")
      }
    }
  }, [_vm._v("Las Vegas Orthodontics - Eastern")]), _c('a', {
    staticClass: "custom-reviews-content__location-button",
    style: ({
      'background': '#3E8EDE'
    }),
    on: {
      "click": function($event) {
        _vm.isLocation("chen")
      }
    }
  }, [_vm._v("Las Vegas Orthodontics - Summerlin")])]) : _vm._e(), (_vm.location == "las") ? _c('div', {
    staticClass: "custom-reviews-content__location-wrap"
  }, [(_vm.yelper == "unknown") ? _c('div', {
    staticClass: "custom-reviews-content__yelper-buttons"
  }, [_c('img', {
    attrs: {
      "src": "https://lvosmiles.com/wp-content/uploads/yelp-logo.png",
      "alt": "yelp-logo"
    }
  }), _c('h1', [_vm._v("Are you a Yelper?")]), _c('a', {
    staticClass: "custom-reviews-content__yelper-button",
    style: ({
      'background': '#3FD5AF'
    }),
    on: {
      "click": function($event) {
        _vm.isYelper("yes")
      }
    }
  }, [_vm._v("YES")]), _c('a', {
    staticClass: "custom-reviews-content__yelper-button",
    style: ({
      'background': '#3E8EDE'
    }),
    on: {
      "click": function($event) {
        _vm.isYelper("no")
      }
    }
  }, [_vm._v("NO")])]) : _vm._e(), (_vm.yelper == "yes") ? _c('a', {
    staticClass: "custom-reviews-content__button",
    style: ({
      'background': '#a0251e'
    }),
    attrs: {
      "href": "https://www.yelp.com/biz/las-vegas-orthodontics-las-vegas-2",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "custom-reviews-content__social-icon",
    attrs: {
      "src": "https://lvosmiles.com/wp-content/uploads/yelp-square.png"
    }
  }), _c('div', {
    staticClass: "custom-reviews-content__text"
  }, [_vm._v("Review us on Yelp")])]) : _vm._e(), (_vm.yelper == "no") ? _c('a', {
    staticClass: "custom-reviews-content__button",
    style: ({
      'background': '#2d417a'
    }),
    attrs: {
      "href": "https://www.facebook.com/lasvegasortho",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "custom-reviews-content__social-icon",
    attrs: {
      "src": "https://lvosmiles.com/wp-content/uploads/fb_icon.png"
    }
  }), _c('div', {
    staticClass: "custom-reviews-content__text"
  }, [_vm._v("Review us on Facebook")])]) : _vm._e(), (_vm.yelper == "no") ? _c('a', {
    staticClass: "custom-reviews-content__button",
    style: ({
      'background': '#e5a30e'
    }),
    attrs: {
      "href": "https://www.google.com/search?q=las+vegas+orthodontics&client=safari&rls=en&ei=ffnrY6yPHuL1kPIP8OeoaA&ved=0ahUKEwjswaz99pX9AhXiOkQIHfAzCg0Q4dUDCBA&uact=5&oq=las+vegas+orthodontics&gs_lcp=Cgxnd3Mtd2l6LXNlcnAQAzILCC4QgAQQxwEQrwEyBQgAEIAEMgUIABCABDIJCAAQFhAeEPEEMgkIABAWEB4Q8QQyCQgAEBYQHhDxBDIJCAAQFhAeEPEEMgkIABAWEB4Q8QQyCQgAEBYQHhDxBDIICAAQFhAeEA86CggAEEcQ1gQQsAM6DQgAEEcQ1gQQyQMQsAM6CAgAEJIDELADOgUIABCRAjoLCC4QxwEQrwEQkQI6CwgAEIAEELEDEIMBOgsILhCABBCxAxCDAToRCC4QgAQQsQMQgwEQxwEQ0QM6DgguEIAEELEDEMcBENEDOggILhCABBDUAjoICAAQgAQQsQM6CwguEIAEEMcBENEDOgQIABBDOgcILhCxAxBDOg4ILhCvARDHARCxAxCABDoFCC4QgAQ6CAguEIAEELEDOhAIABCABBCxAxCDARBGEIACOg4ILhCABBCxAxDHARCvAToSCAAQgAQQsQMQgwEQChBGEIACOg0IABCABBCxAxCDARAKOgoILhCABBCxAxAKOhAILhCABBCxAxDHARCvARAKOg0ILhCABBCxAxCDARAKOgoIABCABBCxAxAKOg0ILhCABBDHARCvARAKOgYIABAWEB5KBAhBGABKBAhGGABQuAtYwh5gox9oA3ABeACAAX6IAawPkgEEMTkuM5gBAKABAcgBCsABAQ&sclient=gws-wiz-serp#lrd=0x80c8c51f4405efe3:0xb9cb31397a77f9ea,3,,,,",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "custom-reviews-content__social-icon",
    attrs: {
      "src": "https://lvosmiles.com/wp-content/uploads/new-google-favicon-512.png"
    }
  }), _c('div', {
    staticClass: "custom-reviews-content__text"
  }, [_vm._v("Review us on Google")])]) : _vm._e()]) : _vm._e(), (_vm.location == "chen") ? _c('div', {
    staticClass: "custom-reviews-content__location-wrap"
  }, [(_vm.yelper == "unknown") ? _c('div', {
    staticClass: "custom-reviews-content__yelper-buttons"
  }, [_c('img', {
    attrs: {
      "src": "https://lvosmiles.com/wp-content/uploads/yelp-logo.png",
      "alt": "yelp-logo"
    }
  }), _c('h1', [_vm._v("Are you a Yelper?")]), _c('a', {
    staticClass: "custom-reviews-content__yelper-button",
    style: ({
      'background': '#3FD5AF'
    }),
    on: {
      "click": function($event) {
        _vm.isYelper("yes")
      }
    }
  }, [_vm._v("YES")]), _c('a', {
    staticClass: "custom-reviews-content__yelper-button",
    style: ({
      'background': '#3E8EDE'
    }),
    on: {
      "click": function($event) {
        _vm.isYelper("no")
      }
    }
  }, [_vm._v("NO")])]) : _vm._e(), (_vm.yelper == "yes") ? _c('a', {
    staticClass: "custom-reviews-content__button",
    style: ({
      'background': '#a0251e'
    }),
    attrs: {
      "href": "https://www.yelp.com/biz/welch-orthodontics-las-vegas",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "custom-reviews-content__social-icon",
    attrs: {
      "src": "https://lvosmiles.com/wp-content/uploads/yelp-square.png"
    }
  }), _c('div', {
    staticClass: "custom-reviews-content__text"
  }, [_vm._v("Review us on Yelp")])]) : _vm._e(), (_vm.yelper == "no") ? _c('a', {
    staticClass: "custom-reviews-content__button",
    style: ({
      'background': '#2d417a'
    }),
    attrs: {
      "href": "https://www.facebook.com/welchorthodontic",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "custom-reviews-content__social-icon",
    attrs: {
      "src": "https://lvosmiles.com/wp-content/uploads/fb_icon.png"
    }
  }), _c('div', {
    staticClass: "custom-reviews-content__text"
  }, [_vm._v("Review us on Facebook")])]) : _vm._e(), (_vm.yelper == "no") ? _c('a', {
    staticClass: "custom-reviews-content__button",
    style: ({
      'background': '#e5a30e'
    }),
    attrs: {
      "href": "https://www.google.com/search?q=welch+orthodontics+vegas&client=safari&rls=en&ei=TZ3uY87TCM3N0PEPzp6UuAQ&ved=0ahUKEwiOrum9-5r9AhXNJjQIHU4PBUcQ4dUDCBA&uact=5&oq=welch+orthodontics+vegas&gs_lcp=Cgxnd3Mtd2l6LXNlcnAQAzIJCAAQFhAeEPEEMgUIABCGAzIFCAAQhgMyBQgAEIYDMgUIABCGAzIFCAAQhgM6CggAEEcQ1gQQsAM6DQgAEEcQ1gQQyQMQsAM6CAgAEJIDELADSgQIQRgAUJAFWO8TYL0VaAFwAXgAgAFmiAG3BJIBAzQuMpgBAKABAcgBBsABAQ&sclient=gws-wiz-serp#lrd=0x80c8c000598318d1:0x13f7377ad29c56da,3,,,,",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "custom-reviews-content__social-icon",
    attrs: {
      "src": "https://lvosmiles.com/wp-content/uploads/new-google-favicon-512.png"
    }
  }), _c('div', {
    staticClass: "custom-reviews-content__text"
  }, [_vm._v("Review us on Google ")])]) : _vm._e()]) : _vm._e()]), (_vm.location == "chen" || _vm.location == "las") ? _c('h5', {
    staticClass: "center custom-reviews-content__heading"
  }, [_vm._v(" If you have not written more than 10 reviews on Yelp, please click “No” to submit a Google or Facebook review.       ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navigation-mobile"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.active),
      expression: "!active"
    }],
    staticClass: "navigation-mobile__container"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('div', {
    staticClass: "navigation-mobile__logo"
  }, [_c('Icon', {
    attrs: {
      "name": "logo"
    }
  })], 1)]), _c('div', {
    staticClass: "navigation-mobile__hamburger",
    on: {
      "click": function($event) {
        _vm.active = true
      }
    }
  }, [_vm._v("Menu")])], 1), _c('div', {
    staticClass: "navigation-mobile__links-container",
    class: {
      'navigation-mobile__links-container--active': _vm.active
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active),
      expression: "active"
    }],
    staticClass: "navigation-mobile__container",
    class: {
      "navigation-mobile__container--active": _vm.active
    }
  }, [_c('div', {
    staticClass: "navigation-mobile__links",
    on: {
      "click": function($event) {
        _vm.active = false
      }
    }
  }, [_c('div', {
    staticClass: "navigation-mobile__link"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('div', {
    staticClass: "navigation-mobile__logo"
  }, [_c('Icon', {
    attrs: {
      "name": "logo"
    }
  })], 1)])], 1), _vm._l((_vm.props), function(nav) {
    return (nav.navigation) ? _c('div', {
      staticClass: "navigation-mobile__link"
    }, [_c('router-link', {
      attrs: {
        "to": nav.path
      }
    }, [_c('a', [_vm._v(_vm._s(nav.name))])])], 1) : _vm._e()
  })], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-contact"
  }, [_c('div', {
    staticClass: "form-contact__container"
  }, [(_vm.formSubmitted) ? _c('div', {
    staticClass: "form-contact__success-message"
  }, [_vm._v("Thanks for submitting our form, we will get back to you as soon as possible!")]) : _vm._e(), _c('form', {
    staticClass: "form-contact__form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateBeforeSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-contact__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.first_last_name),
      expression: "first_last_name"
    }],
    staticClass: "form-contact__input",
    class: {
      'form-contact__input--error': _vm.errors.has('first-last-name')
    },
    attrs: {
      "name": "first-last-name",
      "validate": 'required|alpha_spaces',
      "type": "text",
      "placeholder": "First & Last Name"
    },
    domProps: {
      "value": (_vm.first_last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.first_last_name = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('first-last-name')),
      expression: "errors.has('first-last-name')"
    }],
    staticClass: "form-contact__danger"
  }, [_vm._v(_vm._s(_vm.errors.first('first-last-name')))])]), _c('div', {
    staticClass: "form-contact__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone_number),
      expression: "phone_number"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    staticClass: "form-contact__input",
    class: {
      'input': true, 'form-contact__input--error': _vm.errors.has('phone')
    },
    attrs: {
      "name": "phone",
      "placeholder": "Phone Number"
    },
    domProps: {
      "value": (_vm.phone_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone_number = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('phone')),
      expression: "errors.has('phone')"
    }],
    staticClass: "form-contact__danger"
  }, [_vm._v(_vm._s(_vm.errors.first('phone')))])]), _c('div', {
    staticClass: "form-contact__group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-contact__input",
    class: {
      'input': true, 'form-contact__input--error': _vm.errors.has('email')
    },
    attrs: {
      "name": "message",
      "placeholder": "Message",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })]), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-contact__group"
  }, [_c('input', {
    staticClass: "form-contact__submit-button",
    attrs: {
      "type": "submit",
      "value": "Send"
    }
  })])
}]}

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "fade",
    staticClass: "custom-comfort-care-sections"
  }, _vm._l((_vm.props), function(section, i) {
    return _c('div', {
      staticClass: "custom-comfort-care-sections__section"
    }, [_c('div', {
      staticClass: "custom-comfort-care-sections__container"
    }, [_c('div', {
      staticClass: "custom-comfort-care-sections__body",
      class: {
        'custom-comfort-care-sections__body--float': i % 2
      }
    }, [_c('div', {
      staticClass: "custom-comfort-care-sections__title",
      domProps: {
        "innerHTML": _vm._s(section.title)
      }
    }), _c('div', {
      staticClass: "custom-comfort-care-sections__content",
      domProps: {
        "innerHTML": _vm._s(section.content)
      }
    })]), _c('div', {
      ref: "slide",
      refInFor: true,
      staticClass: "custom-comfort-care-sections__image",
      class: {
        'custom-comfort-care-sections__image--float': i % 2
      },
      style: ({
        backgroundImage: 'url(' + section.image + ')'
      })
    })])])
  }))
},staticRenderFns: []}

/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "fade",
    staticClass: "custom-new-patients-first-visit"
  }, [_c('div', {
    staticClass: "custom-new-patients-first-visit__bg"
  }, [_c('object', {
    attrs: {
      "type": "image/svg+xml",
      "data": _vm.props.background_text
    }
  })]), _c('div', {
    staticClass: "custom-new-patients-first-visit__container"
  }, [_c('div', {
    staticClass: "custom-new-patients-first-visit__body"
  }, [_c('div', {
    staticClass: "custom-new-patients-first-visit__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-new-patients-first-visit__content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.text)
    }
  })])]), _c('div', {
    ref: "slide",
    staticClass: "custom-new-patients-first-visit__image",
    style: ({
      backgroundImage: 'url(' + _vm.props.image + ')'
    })
  })])
},staticRenderFns: []}

/***/ }),
/* 608 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-new-patients"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('CustomNewPatientsFirstVisit', {
    attrs: {
      "props": _vm.props.acf.custom_new_patients_first_visit
    }
  }), _c('CustomNewPatientsConsultation', {
    attrs: {
      "props": _vm.props.acf.custom_new_patients_consultation
    }
  }), _c('CustomNewPatientsTabs', {
    attrs: {
      "props": _vm.props.acf.custom_new_patients_tabs
    }
  }), _c('DividerText', {
    attrs: {
      "props": _vm.props.acf.divider_text
    }
  }), _c('BlockParagraph', {
    attrs: {
      "props": _vm.props.acf.block_paragraph
    }
  }), _c('DividerLogos', {
    attrs: {
      "props": _vm.props.acf.divider_logos
    }
  }), _c('Modal')], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider-testimonials"
  }, [_c('div', {
    staticClass: "slider-testimonials__container"
  }, [_c('div', {
    staticClass: "slider-testimonials__title"
  }, [_c('object', {
    attrs: {
      "aria-label": "lvosmiles reviews",
      "type": "image/svg+xml",
      "data": _vm.props.icon
    }
  })]), _c('div', {
    staticClass: "slider-testimonials__slider"
  }, [_c('div', {
    staticClass: "slider-testimonials__slides"
  }, [_c('Carousel', {
    ref: "testimonial-carousel",
    attrs: {
      "autoplay": false,
      "perPage": 1,
      "loop": true,
      "paginationEnabled": false
    }
  }, _vm._l((_vm.props.testimonials), function(testimonial, i) {
    return _c('Slide', {
      key: i,
      staticClass: "slider-testimonials__slide"
    }, [_c('div', {
      staticClass: "slider-testimonials__slide-body"
    }, [_c('div', {
      staticClass: "slider-testimonials__quotes"
    }, [_c('Icon', {
      attrs: {
        "name": "quotes"
      }
    })], 1), _c('div', {
      staticClass: "slider-testimonials__body"
    }, [_c('div', {
      staticClass: "slider-testimonials__testimonial",
      domProps: {
        "innerHTML": _vm._s(testimonial.text)
      }
    }), _c('div', {
      staticClass: "slider-testimonials__author",
      domProps: {
        "innerHTML": _vm._s(testimonial.author)
      }
    })]), _c('div', {
      staticClass: "slider-testimonials__image",
      style: ({
        backgroundImage: 'url(' + testimonial.image + ')'
      })
    })])])
  })), _c('div', {
    staticClass: "slider-testimonials__arrow slider-testimonials__arrow--prev",
    on: {
      "click": function($event) {
        _vm.SlideCarousel('prev')
      }
    }
  }, [_vm._v("< prev       ")]), _c('div', {
    staticClass: "slider-testimonials__arrow slider-testimonials__arrow--next",
    on: {
      "click": function($event) {
        _vm.SlideCarousel('next')
      }
    }
  }, [_vm._v("next >       ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-comfort-care"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), (!_vm.loading && _vm.props) ? _c('div', [_c('BlockSvgTitle', {
    attrs: {
      "props": _vm.props.acf.block_svg_title
    }
  }), _c('CustomComfortCareSections', {
    attrs: {
      "props": _vm.props.acf.sections
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-svg-title"
  }, [(_vm.props) ? _c('div', {
    staticClass: "block-svg-title__container"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.main_text)
    }
  }), (_vm.props.background_text) ? _c('Icon', {
    staticClass: "block-svg-title__bg",
    attrs: {
      "name": _vm.props.background_text
    }
  }) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arrow-down.svg": 509,
	"./arrow.svg": 510,
	"./calendar.svg": 511,
	"./close.svg": 512,
	"./comfort-care-lvo.svg": 513,
	"./comfort-care.svg": 514,
	"./google-circle.svg": 515,
	"./logo-active.svg": 516,
	"./logo-footer.svg": 517,
	"./logo.svg": 518,
	"./phone.svg": 519,
	"./quotes.svg": 520,
	"./star.svg": 521
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 618;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(186);
module.exports = __webpack_require__(185);


/***/ })
]),[619]);


// WEBPACK FOOTER //
// static/js/app.js